(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var followmeAPILegacy = require("./FollowmeAPILegacy");
var followmeAPIv2 = require("./FollowmeAPIv2");
function FollowMeAPIFactory() {}
FollowMeAPIFactory.getExplicit = function (appMode) {
  switch (appMode) {
    case CONSTANTS.APP_MODE_NORMAL:
      return followmeAPIv2;
    case CONSTANTS.APP_MODE_LEGACY:
    default:
      return followmeAPILegacy;
  }
};
FollowMeAPIFactory.get = function () {
  var appMode = window.storage.getAppMode();
  if (appMode === null) {
    window.storage.clearToken();
    window.location = './index.html';
    throw new Error("No app mode defined. Please refresh the application");
  }
  return this.getExplicit(appMode);
};
if (typeof window !== "undefined") window.followmeAPI = FollowMeAPIFactory;
module.exports = FollowMeAPIFactory;

},{"./FollowmeAPILegacy":4,"./FollowmeAPIv2":5}],2:[function(require,module,exports){
"use strict";

var Dot = require('./track/Dot');
var Event = require('./track/Event');
var EventCustom = require('./track/EventCustom');
var EventCustomDefinition = require('./track/EventCustomDefinition');
var NMEAFormatter = require('./utils/NMEAFormatter');
function FollowMeMapUtils() {}
FollowMeMapUtils.restoreDot = function (rawDot) {
  var dot = new Dot(rawDot.lat, rawDot.lon);
  var event = this.restoreEvent(rawDot.event, rawDot.eventType);
  if (event) {
    dot.setEventFromTable(event);
  }
  return dot;
};
FollowMeMapUtils.restoreEvent = function (event, eventType) {
  if (!event) return false;
  switch (eventType) {
    case 'Event':
      return new Event(event._id, event._name, event._description, event._color, event._isDefault, event._isDrawable);
    case 'EventCustomDefinition':
      return new EventCustomDefinition(event._id, event._color, event._definition, event._isDrawable);
    case 'EventCustom':
      return new EventCustom(event._id, event._name, event._content, event._color, event._isDrawable);
  }
};

/**
 * Translates a Dots collection to a CSV readable by the sever
 * @param {Dots} dots
 * @param includeCustomEventDefinitions
 * @param {string} format
 * @param {boolean} keepExactContent
 * @returns {string}
 */
FollowMeMapUtils.prepareForExport = function (dots, includeCustomEventDefinitions, format, keepExactContent) {
  if (!format) format = 'csv';
  switch (format) {
    case 'csv':
    default:
      return this.prepareForExportCSV(dots, includeCustomEventDefinitions, keepExactContent);
    case 'nmea':
      return this.prepareForExportNMEA(dots, includeCustomEventDefinitions, keepExactContent);
  }
};

/**
 *
 * @param {Dot[]} dots
 * @param {boolean} includeCustomEventDefinitions
 * @param {boolean} keepExactContent - if the content should be modified (e.g. if the description is missing, taking it from the name)
 * @returns {string}
 */
FollowMeMapUtils.prepareForExportCSV = function (dots, includeCustomEventDefinitions, keepExactContent) {
  var rowSeparator = ';';
  var header = ['lat', 'long', 'EVT_TYPE', 'EVT_DESCR', 'EVT_ID', 'EVT_NAME', 'EVT_COLOR', 'EVT_DEFAULT'];
  var customEventIds = [];
  var definitions = [];
  if (typeof window !== 'undefined') {
    definitions = window.storage.getCustomEventDefinitions();
  }
  if (!keepExactContent) {
    header.concat(['eventCode', 'eventText']);
  }
  if (dots.get().length <= 0) return;
  var populateArrayWithEvent = function populateArrayWithEvent(index, array, dot) {
    if (!dot.hasEvent()) return array;
    var event = dot.getEvent();
    switch (event.constructor.name) {
      case 'Event':
        var keepContentForEvent = keepExactContent;
        var description = event.getDescription();
        var eventId = event.getIsDefault() === true ? event.getId() : 1;
        if (eventId === 65555 || eventId === 65553) keepContentForEvent = true;
        if (!keepContentForEvent && event.getName() && event.getName() !== "" && description !== "") {
          description = event.getName() + ": " + event.getDescription();
        } else if (!keepContentForEvent && event.getName() && event.getName() !== "" && description === "") {
          description = event.getName();
        }
        array[header.indexOf('EVT_TYPE')] = eventId;
        array[header.indexOf('EVT_DESCR')] = description;
        array[header.indexOf('EVT_ID')] = eventId;
        array[header.indexOf('EVT_NAME')] = event.getName();
        array[header.indexOf('EVT_COLOR')] = event.getColor();
        array[header.indexOf('EVT_DEFAULT')] = event.getIsDefault();
        if (!keepContentForEvent) {
          array[header.indexOf('eventCode')] = eventId;
          array[header.indexOf('eventText')] = description;
        }
        break;
      case 'EventCustom':
        var eventIndex = 50000 + index;
        var eventDefinition = definitions.find(function (e) {
          return e._id === event.getId();
        });
        var formattedContent = '';
        Object.keys(event.getContent()).forEach(function (key, i) {
          formattedContent += key + '=' + event.getContent()[key];
          if (i !== Object.keys(event.getContent()).length - 1) {
            formattedContent += ',';
          }
        });
        array[header.indexOf('EVT_TYPE')] = event.getId();
        array[header.indexOf('EVT_DESCR')] = formattedContent;
        array[header.indexOf('eventCode')] = event.getId();
        array[header.indexOf('EVT_COLOR')] = event.getColor();
        array[header.indexOf('eventText')] = JSON.stringify('evenTextWo?');
        break;
      /*
      case 'EventCustom':
        var parseEventText = function () {
          var content = event.getContent();
          var outputArray = [];
           for(var i in content) {
            if(!content.hasOwnProperty(i) || content[i] === null) continue;
            outputArray.push(i+"="+content[i]);
          }
           return outputArray.join(",");
        };
         array[header.indexOf('EVT_TYPE')] = event.getId();
        array[header.indexOf('EVT_DESCR')] = parseEventText();
        array[header.indexOf('eventCode')] = event.getId();
        array[header.indexOf('EVT_COLOR')] = event.getColor();
        array[header.indexOf('eventText')] = parseEventText();
         break;*/
    }
    return array;
  };
  var output = header.join(rowSeparator) + '\n';
  dots.get().forEach(function (dot, index) {
    var event = dot.getEvent();
    if (dot.hasEvent() && event.constructor.name === 'EventCustom') {
      customEventIds.push(event.getId());
    }
  });
  if (includeCustomEventDefinitions) {
    var id = 50000;
    var usedDefinitions = definitions.filter(function (def) {
      return customEventIds.includes(def._definition.code);
    });
    var coordinatesLatitude = dots.get()[0].getLatitude().toString();
    var coordinatesLongitude = dots.get()[0].getLongitude().toString();
    usedDefinitions.forEach(function (def) {
      var outputArray = [coordinatesLatitude, coordinatesLongitude];
      for (var i = 0; i < header.length - 2; i++) {
        outputArray.push("");
      }
      var definition = new EventCustomDefinition(def._id, def._color, def._definition, def._isDrawable);
      outputArray[header.indexOf('EVT_TYPE')] = id;
      outputArray[header.indexOf('EVT_DESCR')] = JSON.stringify(definition.getDefinition());
      outputArray[header.indexOf('eventCode')] = def._id;
      outputArray[header.indexOf('EVT_COLOR')] = definition.getColor();
      outputArray[header.indexOf('eventText')] = JSON.stringify(definition.getDefinition());
      output += outputArray.join(rowSeparator) + '\n';
      id++;
    });
  }
  dots.get().forEach(function (dot, index) {
    var outputArray = [dot.getLatitude().toString(), dot.getLongitude().toString()];

    //Pre-populate events columns with empty values
    for (var i = 0; i < header.length - 2; i++) {
      outputArray.push("");
    }
    outputArray = populateArrayWithEvent(index, outputArray, dot);
    output += outputArray.join(rowSeparator) + '\n';
  });
  return output;
};
FollowMeMapUtils.getNMEAEventRow = function (dot, index, keepExactContent) {
  var event = dot.getEvent();
  var row = [];
  switch (event.constructor.name) {
    case 'Event':
      var description = event.getDescription();
      if (!keepExactContent && event.getName() && event.getName() !== "" && description !== "") {
        description = event.getName() + ": " + event.getDescription();
      } else if (!keepExactContent && event.getName() && event.getName() !== "" && description === "") {
        description = event.getName();
      }
      var eventId = event.getIsDefault() === true ? event.getId() : 1;
      row = ['$IWEVENT', eventId, description, dot.getLongitude(), dot.getLatitude()];
      break;
    case 'EventCustomDefinition':
      var eventIndex = 50000 + index;
      row = ['$IWEVENTDEFINITION', eventIndex, JSON.stringify(event.getDefinition()), dot.getLongitude(), dot.getLatitude()];
      break;
    case 'EventCustom':
      var parseEventText = function parseEventText() {
        var content = event.getContent();
        var outputArray = [];
        for (var i in content) {
          if (!content.hasOwnProperty(i) || content[i] === null) continue;
          outputArray.push(i + "=" + content[i]);
        }
        return outputArray.join(",");
      };
      row = ['$IWEVENT', event.getId(), parseEventText(), dot.getLongitude(), dot.getLatitude()];
      break;
  }
  return row.join(',');
};
FollowMeMapUtils.prepareForExportNMEA = function (dots, includeCustomEventDefinitions) {
  var nmeaFormatter = new NMEAFormatter();
  var output = [];
  var definitions = window.storage.getCustomEventDefinitions();
  var trackname = window.storage.getTrackInfo().fileName.replace(/ /g, "-");
  var id = 50000;
  if (definitions.hasOwnProperty(trackname) && definitions[trackname].length > 0) {
    var coordinatesLatitude = dots.get()[0].getLatitude().toString();
    var coordinatesLongitude = dots.get()[0].getLongitude().toString();
    definitions[trackname].forEach(function (definition) {
      output.push(['$IWEVENTDEFINITION', id, JSON.stringify(definition.getDefinition()), coordinatesLongitude, coordinatesLatitude].join(','));
      id++;
    });
  }
  dots.get().forEach(function (dot, index) {
    var coordinate = dot.getCoordinate();
    if (dot.hasEvent()) {
      output.push(this.getNMEAEventRow(dot, index));
    } else {
      output.push(nmeaFormatter.format(coordinate));
    }
  }.bind(this));
  return output.join('\n');
};
FollowMeMapUtils.getUserConfig = function (company, username) {
  var user = {
    company: '',
    username: ''
  };
  typeof company !== 'undefined' ? user.company = company : user.company = window.storage.getCompany();
  typeof username !== 'undefined' ? user.username = username : user.username = window.storage.getUsername();
  var userConfig;
  var specificUsernameKey = user.company + "/" + user.username;
  var specificCompanyKey = user.company + "/*";
  var generalKey = "*/*";
  if (Object.prototype.hasOwnProperty.call(CONSTANTS.MAP_RESTRICTIONS_PER_USER, specificUsernameKey)) {
    userConfig = CONSTANTS.MAP_RESTRICTIONS_PER_USER[specificUsernameKey];
  } else if (Object.prototype.hasOwnProperty.call(CONSTANTS.MAP_RESTRICTIONS_PER_USER, specificCompanyKey)) {
    userConfig = CONSTANTS.MAP_RESTRICTIONS_PER_USER[specificCompanyKey];
  } else {
    userConfig = CONSTANTS.MAP_RESTRICTIONS_PER_USER[generalKey];
  }
  return userConfig;
};
FollowMeMapUtils.sortMapTypes = function (mapTypes) {
  mapTypes.sort(function (a, b) {
    var aString = a.provider + a.version;
    var bString = b.provider + b.version;
    if (aString < bString) {
      return -1;
    }
    if (aString > bString) {
      return 1;
    }
    return 0;
  });
  return mapTypes;
};
if (typeof window !== "undefined") window.FollowMeMapUtils = FollowMeMapUtils;
module.exports = FollowMeMapUtils;

},{"./track/Dot":6,"./track/Event":7,"./track/EventCustom":8,"./track/EventCustomDefinition":9,"./utils/NMEAFormatter":10}],3:[function(require,module,exports){
"use strict";

function FollowMeUtils() {}

/**
 * Creates a hash based on a string
 * Based on https://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
 *
 * @param {string} string
 * @static
 */
FollowMeUtils.hashString = function (string) {
  var hash = 0;
  var character;
  if (string.length === 0) return hash;
  for (var i = 0; i < string.length; i++) {
    character = string.charCodeAt(i);
    hash = (hash << 5) - hash + character;
    hash &= hash; // Convert to 32bit integer
  }
  return hash;
};
module.exports = FollowMeUtils;

},{}],4:[function(require,module,exports){
'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var FollowMeMapUtils = require('./FollowMeMapUtils');
var EventCustomDefinition = require('./track/EventCustomDefinition');

/**
 * General object to provide followme API.
 * @namespace followmeAPILegacy
 */
var followmeAPILegacy = {
  config: {
    dayEventsBaseUrl: window.CONSTANTS.DAY_EVENTS_BASE_URL,
    errorHandler: function ajaxErrorHandler(cb) {
      return function (jqXHR, textStatus, errorThrown) {
        return cb({
          message: errorThrown.message,
          textStatus: textStatus,
          origin: errorThrown
        });
      };
    },
    checkRequestStatus: function checkRequestStatus(response) {
      var status = response.find('STATUS');
      var error = response.find('ERROR');
      var e;
      if (error.length > 0) {
        console.error(error[0].outerHTML);
        throw new Error('Server error');
      }
      if (status.attr('value') !== 'OK') {
        e = new Error(status.attr('message'));
        e.errorcode = status.attr('errorcode');
        throw e;
      }
    },
    mapType: null
  },
  getBaseUrl: function getBaseUrl() {
    switch (window.storage.getAppMode()) {
      case CONSTANTS.APP_MODE_LEGACY:
        return window.CONSTANTS.BASE_URL_LEGACY;
      case CONSTANTS.APP_MODE_NORMAL:
      default:
        return window.CONSTANTS.BASE_URL;
    }
  },
  setMapType: function setMapType(mapType) {
    this.config.mapType = mapType;
  },
  /**
   * Called error on error or empty if all ok
   * @callback defaultCallback
   * @memberof followmeAPILegacy
   * @param {Error} error
   */
  /**
   * Called error on error or with data if all ok
   * @callback defaultDataCallback
   * @memberof followmeAPILegacy
   * @param {Error} error
   * @param {any} data
   */

  /**
   * Returns sessionid token
   * @callback loginCallback
   * @memberof followmeAPILegacy
   * @param {object} error
   * @param {string} sessionid Should be used for access to another followme routes
   */
  /**
   * Get sessionid token for user
   * @async
   * @param {string} company
   * @param {string} username
   * @param {string} password
   * @param {loginCallback} cb
   * */
  login: function login(company, username, password, cb) {
    var url = this.getBaseUrl() + '?CMD=LOGIN&ACAO=TRUE&company=' + company + '&user=' + username + '&pass=' + password;
    var self = this;
    $.ajax({
      type: 'GET',
      url: url,
      success: function success(r) {
        var result;
        try {
          result = $(r);
          self.config.checkRequestStatus(result);
          return cb(null, result.find('STATUS').attr('sessionid'));
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb),
      dataType: 'xml'
    });
  },
  /**
   * Returns result of verification sessionid
   * @callback verifySessionIdCallback
   * @memberof followmeAPILegacy
   * @param {object} error
   * @param {string} sessionid Should be used for access to another followme routes
   */
  /**
   * Verify sessionid token for user
   * @async
   * @param {string} sessionid
   * @param {verifySessionIdCallback} cb
   * */
  verifySessionId: function verifySessionId(sessionid, cb) {
    var url = this.getBaseUrl() + '?CMD=FILELIST&ACAO=TRUE&sessionid=' + sessionid;
    var self = this;
    $.ajax({
      type: 'GET',
      url: url,
      success: function success(r) {
        var result;
        try {
          result = $(r);
          self.config.checkRequestStatus(result);
          return cb(null, true);
        } catch (e) {
          if (e.errorcode === '6') {
            return cb(null, false);
          }
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb),
      dataType: 'xml'
    });
  },
  /**
   * Returns list of files for user
   * @callback fileListCallback
   * @memberof followmeAPILegacy
   * @param {object} error
   * @param {Array} fileList
   */
  /**
   * Get user file list
   * @async
   * @param {string} sessionid Security token
   * @param {fileListCallback} cb
   * */
  fileList: function getFileList(sessionid, cb) {
    var url = this.getBaseUrl() + '?CMD=FILELIST&ACAO=TRUE&sessionid=' + sessionid;
    var toIgnore = ['userSettings', 'dayevents'];
    var self = this;
    function parseRawFile(rawFile) {
      var j;
      var pv;
      var version;
      var date;
      var devices;
      var days;
      var d;
      var k;
      var versionStatusesAndRemarks = [];
      var versions = [];
      var fileStatusesAndRemarks = [];
      var associatedDevices = [];
      var jqFile = $(rawFile);
      var fileName = jqFile.attr('name');
      var jqAssociatedDevices = jqFile.find('DEVICE');
      var statusLastUpdate;
      var lastUsedDevice;
      jqAssociatedDevices.each(function (i, device) {
        associatedDevices.push($(device).attr('ID'));
      });
      window.storage.appendTrackDeviceIdAssociations({
        fileName: fileName,
        deviceIds: associatedDevices
      });
      pv = jqFile.find('version');
      for (j = 0; j < pv.length; j += 1) {
        version = {
          number: $(pv[j]).attr('value'),
          isTemporary: $(pv[j]).attr('temporaryVersionAvailable')
        };
        versionStatusesAndRemarks = [];
        versions.push(version);
        days = $(pv[j]).find('day');
        for (k = 0; k < days.length; k++) {
          var day = $(days[k]);
          date = day.attr('value');
          devices = day.find('device');
          for (d = 0; d < devices.length; d++) {
            var device = $(devices[d]);
            //lastUsedDevice = devices[d].attributes.id.value;
            //statusLastUpdate = device.attr('lastChangeStatusFile');

            versionStatusesAndRemarks.push({
              date: date,
              deviceId: devices[d].attributes.id.value,
              version: version,
              statusLastChangeDate: device.attr('lastChangeStatusFile'),
              remarksLastChangeDate: device.attr('lastChangeRemarksFile')
            });
          }
          versionStatusesAndRemarks.sort(function (a, b) {
            var aDate = new Date(a.statusLastChangeDate);
            var bDate = new Date(b.statusLastChangeDate);
            if (aDate > bDate) {
              return 1;
            } else if (aDate < bDate) {
              return -1;
            } else {
              return 0;
            }
          });
          lastUsedDevice = versionStatusesAndRemarks[versionStatusesAndRemarks.length - 1].deviceId;
          statusLastUpdate = versionStatusesAndRemarks[versionStatusesAndRemarks.length - 1].statusLastChangeDate;
        }
        fileStatusesAndRemarks.push(versionStatusesAndRemarks);
      }
      return {
        fileName: fileName,
        trackName: fileName,
        creationDate: jqFile.attr('creationdate'),
        modificationDate: jqFile.attr('modificationdate'),
        description: jqFile.attr('description'),
        versions: versions,
        published: jqFile.attr('published'),
        statusLastUpdate: statusLastUpdate,
        lastUsedByDevice: lastUsedDevice,
        statusesAndRemarks: fileStatusesAndRemarks,
        associatedDevices: associatedDevices
      };
    }
    function parseFileForFolder(folderName) {
      return function (files, rawFile) {
        if (toIgnore.indexOf(rawFile.attributes.name.value) !== -1) {
          return files;
        }
        var file = parseRawFile(rawFile);
        file.folderName = folderName;
        files.push(file);
        return files;
      };
    }
    $.ajax({
      type: 'GET',
      url: url,
      error: this.config.errorHandler(cb),
      dataType: 'xml',
      success: function success(r) {
        var result;
        var folder;
        var rawFolders = {};
        var folders = {};
        var i;
        try {
          result = $(r);
          self.config.checkRequestStatus(result);
          rawFolders = result.find('folder');
          for (i = 0; i < rawFolders.length; i += 1) {
            folder = $(rawFolders[i]);
            var folderName = folder.attr('name');
            folders[folderName] = folder.find('file').toArray().reduce(parseFileForFolder(folderName), []);
          }
          if (!folders["default"]) folders["default"] = [];
          folders["default"] = folders["default"].concat(result.find('filelist').children('file').toArray().reduce(parseFileForFolder('default'), []));
          return cb(null, folders);
        } catch (e) {
          return cb(e);
        }
      }
    });
  },
  /*
    getAllActiveTracks: function getAllActiveTracks(sessionid, cb) {
      var url = this.config.baseUrl + '?CMD=FILELIST&ACAO=TRUE&sessionid=' + sessionid;
      var toIgnore = ['userSettings', 'dayevents'];
  
      function parseRawFile(rawFile) {
        var j;
        var pv;
        var version;
        var date;
        var devices;
        var days;
        var d;
        var k;
        var versionStatusesAndRemarks = [];
        var versions = [];
        var fileStatusesAndRemarks = [];
        var jqFile = $(rawFile);
        var fileName = jqFile.attr('name');
        let statusLastUpdate;
  
        pv = jqFile.find('version');
        for (j = 0; j < pv.length; j += 1) {
          version = {
            number: $(pv[j]).attr('value'),
            isTemporary: $(pv[j]).attr('temporaryVersionAvailable')
          };
          versionStatusesAndRemarks = [];
          versions.push(version);
  
          days = $(pv[j]).find('day');
          for (k = 0; k < days.length; k++) {
            var day = $(days[k]);
            date = day.attr('value');
            devices = day.find('device');
            for (d = 0; d < devices.length; d++) {
              var device = $(devices[d]);
  
              statusLastUpdate = device.attr('lastChangeStatusFile');
  
              versionStatusesAndRemarks.push({
                date: date,
                deviceId: devices[d].attributes.id.value,
                version: version,
                statusLastChangeDate: device.attr('lastChangeStatusFile'),
                remarksLastChangeDate: device.attr('lastChangeRemarksFile')
              });
            }
          }
          fileStatusesAndRemarks.push(versionStatusesAndRemarks);
  
        }
  
        return {
          fileName: fileName,
          trackName: fileName,
          creationDate: jqFile.attr('creationdate'),
          modificationDate: jqFile.attr('modificationdate'),
          description: jqFile.attr('description'),
          versions: versions,
          published: jqFile.attr('published'),
          statusLastUpdate: statusLastUpdate,
          statusesAndRemarks: fileStatusesAndRemarks
        };
      }
  
      function parseFileForFolder(folderName) {
        return function (files, rawFile) {
          if (toIgnore.indexOf(rawFile.attributes.name.value) !== -1) {
            return files;
          }
  
          var file = parseRawFile(rawFile);
          file.folderName = folderName;
          if(new Date().getTime() - CONSTANTS.STATUS_THRESHOLD_FOR_LIVE_TRACKS < new Date(file.statusLastUpdate).getTime()) {
            //files.push(file);
          }
          files.push(file);
          return files;
        }
      }
  
      $.ajax({
        type: 'GET',
        url: url,
        error: this.config.errorHandler(cb),
        dataType: 'xml',
        success: function success(r) {
          var result;
          var folder;
          var rawFolders = {};
          var folders = {};
          var i;
  
          try {
            result = $(r);
  
            followmeAPI.config.checkRequestStatus(result);
  
            rawFolders = result.find('folder');
            for (i = 0; i < rawFolders.length; i += 1) {
              folder = $(rawFolders[i]);
              var folderName = folder.attr('name');
  
              folders[folderName] = folder.find('file').toArray().reduce(parseFileForFolder(folderName), []);
            }
  
            if (!folders.default) folders.default = [];
            folders.default = folders.default.concat(result.find('filelist').children('file').toArray()
              .reduce(parseFileForFolder('default'), []));
  
            return cb(null, folders);
          } catch (e) {
            return cb(e);
          }
        }
      });
    },*/
  /**
   * Upload file to followme server
   * @async
   * @param {string} sessionid Security token
   * @param {string} data File data
   * @param {string} fileName File name
   * @param {object} trackInfo track information
   * @param {string|int} [trackInfo.version] Target file version
   * @param {string} [trackInfo.folderName] Route folder name
   * @param {defaultCallback} cb
   */
  uploadFile: function uploadFile(sessionid, data, fileName, trackInfo, cb) {
    var url = this.getBaseUrl() + '?CMD=SaveTemporaryPostedRoute&ACAO=TRUE' + '&sessionid=' + sessionid + '&type=route&route=' + encodeURI(getFullRoute(fileName, trackInfo.folderName));
    if (trackInfo.version) url += '&version=' + trackInfo.version;
    var self = this;
    $.ajax({
      method: 'POST',
      url: url,
      data: data,
      success: function success(r) {
        var result;
        try {
          result = $(r);
          self.config.checkRequestStatus(result);
          return cb(null);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * Called with file data on success or with error on error
   * @callback getFileCallback
   * @memberof followmeAPILegacy
   * @param {object} error
   * @param {string} fileData
   */
  /**
   * Get file from followme server
   * @async
   * @param {string} sessionid Security token
   * @param {string} fileName File name
   * @param {object} trackInfo file config
   * @param {number} trackInfo.version Target file version
   * @param {number} trackInfo.folderName file folder
   * @param {boolean} trackInfo.isTemporary is a temporary version
   * @param {getFileCallback} cb
   */
  getFile: function getFile(sessionid, fileName, trackInfo, cb) {
    var url = this.getBaseUrl() + '?CMD=GetFile&ACAO=TRUE' + '&sessionid=' + sessionid + '&type=route&version=' + trackInfo.version + '&route=' + getFullRoute(fileName, trackInfo.folderName);
    if (trackInfo.isTemporary) url += '&temporary=true';
    var self = this;
    $.ajax({
      method: 'GET',
      url: url,
      processData: false,
      success: function success(r) {
        var result;
        if (typeof r === 'string') return cb(null, r);
        try {
          result = $(r);
          self.config.checkRequestStatus(result);
          return cb(result);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * @function setRouteAttributes Set's file metadata
   * @async
   * @param sessionid Security token
   * @param {string} route File name
   * @param {object} attributes Key values map to set {key: 'value'}
   * @param {object} trackInfo route config
   * @param {object} trackInfo.folderName route config
   * @param {defaultCallback} cb
   */
  setRouteAttributes: function setRouteAttributes(sessionid, route, attributes, trackInfo, cb) {
    var url = this.getBaseUrl() + '?CMD=SetRouteAttributes&ACAO=TRUE&sessionid=' + sessionid + '&route=' + getFullRoute(route, trackInfo.folderName);
    url = Object.keys(attributes).reduce(function (urlString, attribute) {
      return urlString + '&' + encodeURI(attribute + '=' + attributes[attribute]);
    }, url);
    var self = this;
    $.ajax({
      method: 'POST',
      url: url,
      processData: false,
      success: function success(r) {
        var result;
        try {
          result = $(r);
          self.config.checkRequestStatus(result);
          return cb(null);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * @function deleteFile Deletes file
   * @async
   * @param sessionid Security token
   * @param {string} fileName File name
   * @param {string} folder Folder name
   * @param {defaultCallback} cb
   */
  deleteFile: function deleteFile(sessionid, fileName, folder, cb) {
    var url = this.getBaseUrl() + '?CMD=DeleteFile&ACAO=TRUE&sessionid=' + sessionid + '&route=' + getFullRoute(fileName, folder);
    var self = this;
    $.ajax({
      method: 'POST',
      url: url,
      processData: false,
      success: function success(r) {
        var result;
        try {
          result = $(r);
          self.config.checkRequestStatus(result);
          return cb(null);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * Called with data or with error
   * @callback isTrackNameFreeCallback
   * @memberof followmeAPILegacy
   * @param {object} error
   * @param {boolean} isTrackNameFree
   */
  /**
   * @function isTrackNameFree
   * @async
   * @param sessionid Security token
   * @param {string} trackInfo
   * @param {isTrackNameFreeCallback} cb
   * @param {string} fileName
   */
  isTrackNameFree: function isTrackNameFree(sessionid, trackInfo, fileName, cb) {
    var result;
    this.fileList(sessionid, function (e, list) {
      if (e) return cb(e);
      try {
        result = checkTrackNameAvailability(list, trackInfo, fileName);
        return cb(null, result);
      } catch (error) {
        return cb(error);
      }
    });
  },
  /**
   * @function uploadTrack Uploads track data and set's metadata
   * @memberof followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} route File name
   * @param {string} trackData
   * @param {object} trackInfo
   * @param {string} [trackInfo.trackName]
   * @param {string} [trackInfo.trackDescription]
   * @param {string} [trackInfo.creationDate]
   * @param {string} [trackInfo.version]
   * @param {string} [trackInfo.folderName]
   * @param {defaultCallback} cb
   */
  uploadTrack: function uploadTrack(sessionid, route, trackData, trackInfo, cb, overwriteFile) {
    var self = this;
    window.async.waterfall([function (callback) {
      if (!trackInfo.trackName) return callback(null, true);
      return self.isTrackNameFree(sessionid, trackInfo, route, callback);
    }, function (isNameFree, callback) {
      if (!isNameFree && !overwriteFile) return callback(new Error('Current track name is already in use'));
      return self.uploadFile(sessionid, trackData, route, {
        version: trackInfo.version,
        folderName: trackInfo.folderName
      }, callback);
    }, function (callback) {
      var mapType = window.storage.getSelectedMapType();
      var attributes = {
        modificationDate: new Date().toISOString(),
        mapName: mapType.name
      };
      if (trackInfo.trackName) attributes.trackName = trackInfo.trackName;
      if (trackInfo.creationDate) attributes.creationDate = trackInfo.creationDate;
      if (trackInfo.trackDescription) attributes.description = trackInfo.trackDescription;
      self.setRouteAttributes(sessionid, route, attributes, {
        folderName: trackInfo.folderName
      }, callback);
    }], function (e) {
      if (e) return cb(e);
      return cb(null);
    });
  },
  /**
   * @function updateTrackMetadata Used to change track name and description
   * @memberof followmeAPILegacy
   * @async
   * @param {string} sessionId Security token
   * @param oldFileName
   * @param oldFolderName
   * @param newFileName
   * @param newFolderName
   * @param trackDescription
   * @param {defaultCallback} cb
   */
  updateTrackMetadata: function updateTrackMetadata(sessionId, oldFileName, oldFolderName, newFileName, newFolderName, trackDescription, cb) {
    var self = this;
    window.async.waterfall([function (callback) {
      self.isTrackNameFree(sessionId, newFileName, oldFileName, callback);
    }, function (isNameFree, callback) {
      if (!isNameFree) {
        return callback(new Error('Current track name is already in use'));
      }
      if (oldFolderName === newFolderName && oldFileName === newFileName) {
        return callback();
      }
      self.moveFile(sessionId, oldFolderName, newFolderName, oldFileName, newFileName, callback);
    }, function (callback) {
      var mapType = window.storage.getSelectedMapType();
      var attributes = {
        modificationDate: new Date().toISOString(),
        description: trackDescription,
        mapName: mapType.name
      };
      return self.setRouteAttributes(sessionId, newFileName, attributes, {
        folderName: newFolderName
      }, callback);
    }], function (e) {
      if (e) return cb(e);
      return cb(null);
    });
  },
  /**
   * @function dotsToTrackData Converts dots to track csv data
   * @memberof followmeAPILegacy
   * @param {object[]} dotsArray Track dots
   * @param {string} dotsArray[].lat - Dot latitude.
   * @param {string} dotsArray[].lon - Dot longitude
   * @returns {string} Track csv data
   */
  dotsToTrackData: function dotsToTrackData(dotsArray) {
    var i;
    var data = 'lat;long;event.name;event.desc;event.color\n';
    var dots = dotsArray || [];
    var eventStr;
    for (i = 0; i < dots.length; i += 1) {
      if (_typeof(dots[i]) !== 'object' || dots[i].lon === undefined || dots[i].lat === undefined) continue;
      if (dots[i].event) {
        eventStr = ';' + dots[i].event.name + ';' + (dots[i].event.desc || dots[i].event.name) + ';' + (dots[i].event.color || '#ffffff');
      } else {
        eventStr = '';
      }
      data += dots[i].lat + ';' + dots[i].lon + eventStr + '\n';
    }
    return data;
  },
  /**
   * @function dotsToRouteData Converts dots to track csv data
   * @memberof followmeAPILegacy
   * @param {Dots} dots Track dots
   * @param includeCustomEventDefinitions
   * @param {string} format
   * @param {boolean} keepExactContent
   * @returns {string} Track csv data
   */
  dotsToRouteData: function dotsToRouteData(dots, includeCustomEventDefinitions, format, keepExactContent) {
    if (!format) format = 'csv';
    return FollowMeMapUtils.prepareForExport(dots, includeCustomEventDefinitions, format, keepExactContent);
  },
  /**
   * @function getUserDevices: Returns current user devices in xml format
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {getUserDevicesCallback} cb
   */
  getUserDevices: function getUserDevices(sessionid, cb) {
    this.getUserSettings(sessionid, function (e, data) {
      try {
        if (e) return cb(e);
        var devices = [];
        var devicesXML = $(data).find('device');
        devicesXML.each(function (index, device) {
          devices.push({
            id: device.getAttribute('id'),
            name: device.getAttribute('name')
          });
        });
        cb(null, devices);
      } catch (error) {
        return cb(error);
      }
    });
  },
  /**
   * Called with user settings on success or with error on error
   * @callback getUserSettingsCallback
   * @memberof followmeAPILegacy
   * @param {Error} error
   * @param {xml} userSettings
   */
  /**
   * @function getUserSettings Returns current user settings in xml format
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {getUserSettingsCallback} cb
   */
  getUserSettings: function getUserSettings(sessionid, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=GetUserSettings&ACAO=TRUE&sessionid=' + sessionid;
    $.ajax({
      method: 'GET',
      url: url,
      success: function success(r) {
        var status = $(r).find('STATUS');
        try {
          if (status.length > 0) {
            self.config.checkRequestStatus($(r));
          }
          return cb(null, r);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * Called with user settings on success or with error on error
   * @callback setUserSettingsCallback
   * @memberof followmeAPILegacy
   * @param {Error} error
   * @param {xml} userSettings
   */
  /**
   * @function setUserSettings Sets current user settings
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {xml} settings User settings
   * @param {setUserSettingsCallback} cb
   */
  setUserSettings: function setUserSettings(sessionid, settings, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=SetUserSettings&ACAO=TRUE&sessionid=' + sessionid;
    $.ajax({
      method: 'POST',
      url: url,
      processData: false,
      data: settings,
      success: function success(r) {
        var status = $(r).find('STATUS');
        try {
          if (status.length > 0) self.config.checkRequestStatus($(r));
          return cb(null, r);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * Called with array of custom user events on success or with error on error
   * @callback getUserEventsCallback
   * @memberof followmeAPILegacy
   * @param {Error} error
   * @param {object[]} custom events
   */
  /**
   * @function getUserEvents Returns array of custom user events
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {getUserEventsCallback} cb
   */
  getUserEvents: function getUserEvents(sessionid, cb) {
    this.getUserSettings(sessionid, function (e, data) {
      var i = 0;
      var events = [];
      var childNodes;
      try {
        if (e) return cb(e);
        // Edge support
        //childNodes = data.lastElementChild ? data.lastElementChild.childNodes : $(data.childNodes.item(0)).find('event');
        childNodes = $(data).find('event');
        for (i = 0; i < childNodes.length; i += 1) {
          events.push({
            name: childNodes[i].getAttribute('name'),
            id: childNodes[i].getAttribute('id'),
            color: childNodes[i].getAttribute('color'),
            desc: childNodes[i].getAttribute('desc')
          });
        }
        cb(null, events);
      } catch (error) {
        return cb(error);
      }
    });
  },
  /**
   * @function addUserEvent Adds new user created event
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} name Custom event name
   * @param {string} color Custom event color
   * @param {string} desc Event description
   * @param {defaultCallback} cb
   */
  addUserEvent: function addUserEvent(sessionid, name, color, desc, cb) {
    var self = this;
    var id = name + '_' + Date.now();
    window.async.waterfall([function (callback) {
      self.getUserSettings(sessionid, callback);
    }, function (data, callback) {
      var userSettings;
      try {
        userSettings = $(data).find('FollowMeServerUserSettings');
        userSettings.append(self.createEventXmlRow(id, name, color, desc));
        self.setUserSettings(sessionid, userSettings[0].outerHTML, callback);
      } catch (e) {
        callback(e);
      }
    }], function (e) {
      if (e) return cb(e);
      return cb(null);
    });
  },
  /**
   * @function deleteUserEvent Deletes user event by id
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} id EventId
   * @param {defaultCallback} cb
   */
  deleteUserEvent: function addUserEvent(sessionid, id, cb) {
    var self = this;
    window.async.waterfall([function (callback) {
      self.getUserSettings(sessionid, callback);
    }, function (data, callback) {
      var userSettings;
      try {
        userSettings = $(data).find('FollowMeServerUserSettings');
        userSettings.find("[id='" + id + "']").remove();
        self.setUserSettings(sessionid, userSettings[0].outerHTML, callback);
      } catch (e) {
        callback(e);
      }
    }], function (e) {
      if (e) return cb(e);
      return cb(null);
    });
  },
  getCustomEventDefinitions: function getCustomEventDefinitions(sessionid, trackname, callback) {
    this.getUserSettings(sessionid, function (e, data) {
      //TODO: Remove this hack after it applied
      var dataNeedsSaving = false;
      $(data).find('customeventdefinition').each(function () {
        var codeId = parseInt($(this).attr('code'));
        var contentId = parseInt(JSON.parse($(this).text())["code"]);
        if (codeId !== contentId) {
          dataNeedsSaving = true;
          $(this).attr("code", contentId);
        }
      });
      if (dataNeedsSaving) {
        try {
          this.setUserSettings(sessionid, data, function (a, b) {});
        } catch (e) {
          console.error(e);
        }
      }
      //TODO: Remove this hack after it applied

      this.saveCustomDefinitionEventsCache($(data));
      if (trackname === null) {
        return callback();
      }
      var i = 0;
      var events = [];
      var childNodes;

      // Edge support
      childNodes = getCustomEventNodeByFilename($(data).find('customeventdefinition'), trackname.replace(/ /g, '-'));
      for (i = 0; i < childNodes.length; i += 1) {
        try {
          var event = childNodes[i];
          events.push(new EventCustomDefinition(event.attr("code"), event.attr("color") ? event.attr("color") : "#5c9eed", JSON.parse(event.text()), true));
        } catch (e) {
          callback(e);
        }
      }
      callback(null, events);
    }.bind(this));
  },
  /**
   * Saves a new Custom Event Definition on the track
   *
   * @param code
   * @param {string} name
   * @param {string} color
   * @param {object} content
   */
  addNewEventCustomDefinition: function addNewEventCustomDefinition(code, name, color, content) {
    var getNextFreeDefinitionCode = function () {
      var code = 40000;
      var currentTrack = window.storage.getTrackInfo().fileName.replace(/ /g, '-');
      var definitions = [];
      var cachedCustomEventDefinitions = window.storage.getCustomEventDefinitions();
      if (cachedCustomEventDefinitions.hasOwnProperty(currentTrack)) {
        definitions = cachedCustomEventDefinitions[currentTrack];
      }
      definitions.forEach(function (definition) {
        var newCode = parseInt(definition.getId());
        if (newCode > code) {
          code = newCode;
        }
      });
      return ++code;
    }.bind(this);
    if (!code) {
      code = getNextFreeDefinitionCode();
    }
    var eventContent = {
      title: name,
      type: "object",
      code: code,
      properties: {},
      required: []
    };
    for (var property in content) {
      if (!content.hasOwnProperty(property)) continue;
      eventContent.properties[property] = {
        type: content[property].type
      };
      if (content[property].required) eventContent['required'].push(property);
    }
    var eventDefinition = new EventCustomDefinition(code, color, eventContent, true);
    this.saveEventDefinitionsForTrack(window.storage.getUserToken(), window.storage.getTrackInfo().fileName, [eventDefinition]);
  },
  saveEventDefinitionsForTrack: function saveEventDefinitionsForTrack(sessionid, filename, definitions, parentCallback) {
    if (definitions.length === 0) return;
    var self = this;
    window.async.waterfall([function (callback) {
      self.getUserSettings(sessionid, callback);
    }, function (data, callback) {
      var customEventDefinitions;
      try {
        var settings = $(data).find('FollowMeServerUserSettings');
        customEventDefinitions = settings.find('customeventdefinitions');
        if (customEventDefinitions.length === 0) {
          customEventDefinitions = $("<customeventdefinitions>");
          settings.append(customEventDefinitions);
        }
        definitions.forEach(function (definition) {
          var customEventDefinition = getCustomEventNodeByFilenameAndCode(customEventDefinitions.find("customeventdefinition"), filename.replace(/ /g, '-'), definition.getId());
          if (customEventDefinition === null) {
            customEventDefinition = $("<customeventdefinition>");
            customEventDefinition.attr('filename', filename.replace(/ /g, '-'));
            customEventDefinition.attr('code', definition.getId());
            customEventDefinition.attr('timestamp', Date.now());
            customEventDefinitions.append(customEventDefinition);
          }
          customEventDefinition.attr('color', definition.getColor());
          customEventDefinition.text(JSON.stringify(definition.getDefinition()));
        });
        self.setUserSettings(sessionid, settings[0].outerHTML, callback);
        var newDefinitions = self.saveCustomDefinitionEventsCache(settings[0].outerHTML);
        window.updateCustomEventsDefinitions(null, newDefinitions);
        if (typeof parentCallback != 'undefined') {
          parentCallback();
        }
      } catch (e) {
        console.error("FollowmeApi.js:741", e);
        callback(e);
      }
    }]);
  },
  /**
   * Removes a custom event definition from the dots
   *
   * @param sessionid
   * @param filename
   * @param {int} code
   */
  removeEventCustomDefinition: function removeEventCustomDefinition(sessionid, filename, code) {
    var self = this;
    window.async.waterfall([function (callback) {
      self.getUserSettings(sessionid, callback);
    }, function (data, callback) {
      var customEventDefinitions;
      try {
        var settings = $(data).find('FollowMeServerUserSettings');
        customEventDefinitions = settings.find('customeventdefinitions');
        var customEventDefinition = customEventDefinitions.find("[filename=" + filename.replace(/ /g, '-') + "][code=" + code + "]");
        customEventDefinition.remove();
        self.setUserSettings(sessionid, settings[0].outerHTML, callback);
        var newDefinitions = self.saveCustomDefinitionEventsCache(settings[0].outerHTML);
        window.updateCustomEventsDefinitions(null, newDefinitions);
      } catch (e) {
        console.error("FollowmeApi.js:791", e);
        callback(e);
      }
    }]);
  },
  saveCustomDefinitionEventsCache: function saveCustomDefinitionEventsCache(xml) {
    var definitions = {};
    $(xml).find('customeventdefinition').each(function () {
      var filename = $(this).attr("filename");
      if (!definitions.hasOwnProperty(filename)) {
        definitions[filename] = [];
      }
      definitions[filename].push(new EventCustomDefinition($(this).attr("code"), $(this).attr("color") ? $(this).attr("color") : "#5c9eed", JSON.parse($(this).text()), true));
    });
    window.storage.saveCustomEventDefinitions(definitions);
    return definitions;
  },
  /**
   * @function modifyUserEvent Deletes user event by id
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} id EventId
   * @param {string} name Event name
   * @param {string} color Event color
   * @param {string} desc Event description
   * @param {defaultCallback} cb
   */
  modifyUserEvent: function modifyUserEvent(sessionid, id, name, color, desc, cb) {
    var self = this;
    window.async.waterfall([function (callback) {
      self.getUserSettings(sessionid, callback);
    }, function (data, callback) {
      var userSettings;
      try {
        userSettings = $(data).find('FollowMeServerUserSettings');
        userSettings.find("[id='" + id + "']").remove();
        userSettings.append(self.createEventXmlRow(id, name, color, desc));
        self.setUserSettings(sessionid, userSettings[0].outerHTML, callback);
      } catch (e) {
        callback(e);
      }
    }], function (e) {
      if (e) return cb(e);
      return cb(null);
    });
  },
  /**
   * @function createEventXmlRow Creates custom event in xml format
   * @memberOf followmeAPILegacy
   * @param {string} id
   * @param {string} name
   * @param {string} color
   * @param {string} desc
   * @returns {HTMLElement}
   */
  createEventXmlRow: function createEventXmlRow(id, name, color, desc) {
    var doc = document.implementation.createDocument('', '', null);
    var event = doc.createElement('event');
    event.setAttribute('id', id);
    event.setAttribute('name', name);
    event.setAttribute('color', color);
    event.setAttribute('desc', desc);
    return event;
  },
  /**
   * Called with calculated route data on success or with error on error
   * @callback calculatePostedRouteCallback
   * @memberof followmeAPILegacy
   * @param {Error} error
   * @param {data} Calculated route data
   */
  /**
   * @function calculatePostedRoute Created route for track
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} data Csv data with lat/long dots in mercator
   * @param {calculatePostedRouteCallback} cb
   */
  calculatePostedRoute: function calculatePostedRoute(sessionid, data, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=CalcPostedRoute&ACAO=TRUE&sessionid=' + sessionid;
    if (this.config.mapType !== null) {
      if (this.config.mapType.hasOwnProperty('hasRouting') && this.config.mapType.hasRouting === false) {
        var userConfig = FollowMeMapUtils.getUserConfig();
        url += "&MAP=" + userConfig.defaultTo;
      } else {
        url += "&MAP=" + this.config.mapType.name;
      }
    }
    $.ajax({
      method: 'POST',
      url: url,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      },
      data: data,
      processData: false,
      success: function success(r) {
        var status = $(r).find('STATUS');
        try {
          if (status.length > 0) self.config.checkRequestStatus($(r));
          return cb(null, r);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * @function releasePostedRoute Publishes route for user access
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} data Csv data with lat/long dots
   * @param {string} route Route file name
   * @param {string} folderName Route folder name
   * @param {defaultCallback} cb
   */
  releasePostedRoute: function releasePostedRoute(sessionid, data, route, folderName, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=ReleasePostedRoute&ACAO=TRUE&route=' + getFullRoute(route, folderName) + '&sessionid=' + sessionid;
    $.ajax({
      method: 'POST',
      url: url,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      },
      data: data,
      processData: false,
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * @function unReleaseRoute Unpublishes route for user access
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} route Route file name
   * @param {string} folderName file folder
   * @param {defaultCallback} cb
   */
  unReleaseRoute: function unReleaseRoute(sessionid, route, folderName, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=UnreleaseRoute&ACAO=TRUE&route=' + getFullRoute(route, folderName) + '&sessionid=' + sessionid;
    $.ajax({
      method: 'POST',
      url: url,
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   *
   * @param sessionid
   * @param route
   * @param folder
   * @param deviceId
   * @param cb
   */
  addDeviceToTrack: function addDeviceToTrack(sessionid, route, folder, deviceId, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=AddDevice&ACAO=TRUE&device=' + deviceId + '&route=' + getFullRoute(route, folder) + '&sessionid=' + sessionid;
    $.ajax({
      method: 'POST',
      url: url,
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   *
   * @param sessionid
   * @param route
   * @param folder
   * @param deviceId
   * @param cb
   */
  deleteDeviceFromTrack: function deleteDeviceFromTrack(sessionid, route, folder, deviceId, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=DeleteDevice&ACAO=TRUE&device=' + deviceId + '&route=' + getFullRoute(route, folder) + '&sessionid=' + sessionid;
    $.ajax({
      method: 'POST',
      url: url,
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   *
   * @callback getRouteStatusesAndRemarksCallback
   * @memberof followmeAPILegacy
   * @param {Error} error
   * @param {object} statusAndRemarks
   */
  /**
   * @function getRouteStatusesAndRemarks Returns route statuses and remarks
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} route File name
   * @param {string} folder Folder name
   * @param {getRouteStatusesAndRemarksCallback} cb
   */
  getRouteStatusesAndRemarks: function getRouteStatusesAndRemarks(sessionid, route, folder, cb) {
    folder = folder || 'default';
    var self = this;
    window.async.waterfall([function (cb) {
      self.fileList(sessionid, cb);
    }, function (fileList, cb) {
      var file = fileList[folder].find(function (file) {
        return file.fileName === route;
      });
      if (!file) return cb();
      cb(null, file.statusesAndRemarks);
    }], function (error, statusAndRemarks) {
      if (error) return cb(error);
      cb(null, statusAndRemarks);
    });
  },
  /**
   * @function getRouteRemark Returns target remarks
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} route File name
   * @param {string} date remarks date
   * @param {string} deviceId remarks deviceid
   * @param {number} version remarks version
   * @param {string} folderName route folder name
   * @param {defaultDataCallback} cb
   */
  getRouteRemark: function getRouteRemark(sessionid, route, date, deviceId, version, folderName, cb) {
    var url = this.getBaseUrl() + '?CMD=GetRemarks&ACAO=TRUE&sessionid=' + sessionid + '&route=' + getFullRoute(route, folderName) + '&version=' + version + '&day=' + date + '&device=' + deviceId;
    $.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      error: this.config.errorHandler(cb),
      success: function success(r) {
        try {
          return cb(null, r);
        } catch (e) {
          return cb(e);
        }
      }
    });
  },
  /**
   * @function getRouteStatus Returns target status
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} route File name
   * @param {string} date remarks date
   * @param {string} deviceId remarks deviceid
   * @param {number} version remarks version
   * @param {string} folderName route folder name
   * @param {defaultDataCallback} cb
   */
  getRouteStatus: function getRouteStatus(sessionid, route, date, deviceId, version, folderName, cb) {
    var url = this.getBaseUrl() + '?CMD=GetStatus&ACAO=TRUE&sessionid=' + sessionid + '&route=' + getFullRoute(route, folderName) + '&version=' + version + '&day=' + date + '&device=' + deviceId;
    if (this.config.mapType !== null) {
      url += "&MAP=" + this.config.mapType.name;
    }
    $.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      error: this.config.errorHandler(cb),
      success: function success(r) {
        try {
          return cb(null, r);
        } catch (e) {
          return cb(e);
        }
      }
    });
  },
  /**
   * @function uploadDayEvent Compresses and uploads day events data
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} data day events data
   * @param {defaultCallback} cb
   */
  uploadDayEvents: function uploadDayEvent(sessionid, data, cb) {
    var url = this.config.dayEventsBaseUrl + '?CMD=UploadFile&sessionid=' + sessionid + '&type=dayevents&ACAO=TRUE';
    $.ajax({
      method: 'POST',
      url: url,
      headers: {
        'Content-type': 'text/plain'
      },
      data: window.pako.deflate(data),
      processData: false,
      success: function success(r) {
        cb();
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * @function getDayEvents Returns parsed day events
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {defaultDataCallback} cb
   */
  getDayEvents: function getDayEvents(sessionid, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=GetDayEvents&ACAO=TRUE&version=0&sessionid=' + sessionid + '&route=dayevents';
    $.ajax({
      type: 'GET',
      url: url,
      error: this.config.errorHandler(cb),
      success: function success(r) {
        try {
          return cb(null, self.parseRawDayEvents(r));
        } catch (e) {
          return cb(e);
        }
      }
    });
  },
  /**
   * @function dayEventJsonToXml Converts day event object to xml row
   * @memberOf followmeAPILegacy
   * @param {DayEvent} dayEvent
   */
  dayEventJsonToXml: function dayEventJsonToXml(dayEvent) {
    var wgs84cords = dayEvent.coordinates.toWGS84();
    return $("<DAYEVENT>", {
      description: dayEvent.name,
      coordx: wgs84cords._x,
      coordy: wgs84cords._y
    }).append($("<DATE>", {
      type: dayEvent.type,
      from: dayEvent.fromDate,
      to: dayEvent.toDate,
      weekday: weekDayToNumber(dayEvent.weekday)
    }))[0];
  },
  /**
   * @function dayEventsToXml Creates day events xml from DayEvent array
   * @memberOf followmeAPILegacy
   * @param {DayEvent[]} dayEvents
   */
  dayEventsToXml: function dayEventsToXml(dayEvents) {
    var xmlVersion = '<?xml version="1.0"?>\n';
    var dayEventsRows = dayEvents.map(this.dayEventJsonToXml);
    var xml = $("<FOLLOWME>").append($('<DAYEVENTS>', {
      tour: ""
    }).append(dayEventsRows));
    return xmlVersion + xml[0].outerHTML;
  },
  /**
   *
   * @callback modifyDayEventsCallback
   * @memberof followmeAPILegacy
   * @param {Error} error
   * @param {DayEvent[]} updatedDayEvents
   */
  /**
   * @function modifyDayEvents Loads day events passes to function and uploads to server
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {Function} fn function to modify day events array
   * @param {modifyDayEventsCallback} callback
   */
  modifyDayEvents: function addDayEvent(sessionid, fn, callback) {
    var self = this;
    var updatedDayEvents;
    window.async.waterfall([function (cb) {
      self.getDayEvents(sessionid, cb);
    }, function (dayEvents, cb) {
      try {
        dayEvents = fn(dayEvents);
        updatedDayEvents = dayEvents;
        self.uploadDayEvents(sessionid, self.dayEventsToXml(dayEvents), cb);
      } catch (e) {
        cb(e);
      }
    }], function (e) {
      callback(e, updatedDayEvents);
    });
  },
  /**
   * @function addDayEvent
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {DayEvent} dayEvent day event to add
   * @param {modifyDayEventsCallback} callback
   */
  addDayEvent: function addDayEvent(sessionid, dayEvent, callback) {
    function isEventNameUniq(dayEvents) {
      return !dayEvents.find(function (event) {
        return event.name === dayEvent.name;
      });
    }
    this.modifyDayEvents(sessionid, function (dayEvents) {
      if (!isEventNameUniq(dayEvents)) {
        throw new Error('Event name "' + dayEvent.name + '" already in use!');
      }
      dayEvents.push(dayEvent);
      return dayEvents;
    }, callback);
  },
  /**
   * @function parseRawDayEvents Convertes xml to DayEvent[]
   * @param {xml} rawDayEvents
   * @returns {DayEvent[]}
   */
  parseRawDayEvents: function parseRawDayEvents(rawDayEvents) {
    if (!rawDayEvents.features) {
      return [];
    }
    return rawDayEvents.features.map(function (feature) {
      return {
        name: feature.properties.TEXT,
        type: feature.properties.TYPE.toLowerCase(),
        weekday: getWeekDayLiteral(+feature.properties.WEEKDAY),
        fromDate: +feature.properties.UTC_FROM,
        toDate: +feature.properties.UTC_TO,
        coordinates: new IWCoordinate(feature.geometry.coordinates[0], feature.geometry.coordinates[1], IWCoordinate.MERCATOR)
      };
    });
  },
  /**
   * @function addDayEvent
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} originalName Original day event name
   * @param {DayEvent} dayEvent day event to update
   * @param {modifyDayEventsCallback} callback
   */
  updateDayEvent: function updateDayEvent(sessionid, originalName, dayEvent, callback) {
    this.modifyDayEvents(sessionid, function (dayEvents) {
      var targetEventIndex = dayEvents.findIndex(function (event) {
        return event.name === originalName;
      });
      if (targetEventIndex === -1) throw new Error('Event with name "' + originalName + '" do not exists!');
      dayEvents[targetEventIndex] = dayEvent;
      return dayEvents;
    }, callback);
  },
  /**
   * @function addDayEvent
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {DayEvent} dayEvent day event to delete
   * @param {modifyDayEventsCallback} callback
   */
  deleteDayEvent: function deleteDayEvent(sessionid, dayEvent, callback) {
    this.modifyDayEvents(sessionid, function (dayEvents) {
      dayEvents = dayEvents.filter(function (event) {
        return event.name !== dayEvent.name;
      });
      return dayEvents;
    }, callback);
  },
  /**
   * @function createFolder Creates folder for user
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} folderName
   * @param {defaultCallback} cb
   */
  createFolder: function createFolder(sessionid, folderName, cb) {
    var self = this;
    var url = this.config.dayEventsBaseUrl + '?CMD=CreateFolder&sessionid=' + sessionid + '&ACAO=TRUE&folder=/' + folderName;
    $.ajax({
      method: 'POST',
      url: url,
      processData: false,
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * @function renameFolder Renames folder of user
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} oldFolderName
   * @param {string} newFolderName
   * @param {defaultCallback} cb
   */
  renameFolder: function renameFolder(sessionid, oldFolderName, newFolderName, cb) {
    var self = this;
    var url = this.config.dayEventsBaseUrl + '?CMD=RenameFolder&sessionid=' + sessionid + '&ACAO=TRUE&' + 'folder=/' + oldFolderName + '&newFolder=/' + newFolderName;
    $.ajax({
      method: 'POST',
      url: url,
      processData: false,
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * @function deleteFolder Deletes user`s folder
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} folderName Folder to delete
   * @param {defaultCallback} cb
   */
  deleteFolder: function deleteFolder(sessionid, folderName, cb) {
    var self = this;
    var url = this.config.dayEventsBaseUrl + '?CMD=DeleteFolder&sessionid=' + sessionid + '&ACAO=TRUE&folder=/' + folderName;
    $.ajax({
      method: 'POST',
      url: url,
      processData: false,
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * @function moveFile moves file to new folder
   * @async
   * @memberOf followmeAPILegacy
   * @param {string} sessionid Security token
   * @param {string} oldFolder Old folder name
   * @param {string} newFolder New folder name
   * @param {string} oldFileName
   * @param {string} newFileName
   * @param {defaultCallback} cb
   */
  moveFile: function moveFile(sessionid, oldFolder, newFolder, oldFileName, newFileName, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=MoveFile&sessionid=' + sessionid + '&ACAO=TRUE' + '&folder=' + oldFolder + '&file=' + getFullRoute(oldFileName, oldFolder) + '&newPath=' + getFullRoute(newFileName, newFolder);
    $.ajax({
      method: 'POST',
      url: url,
      processData: false,
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * @function getMapTypes Gets all the map types available on the NaviServer
   * @async
   * @memberOf followmeAPILegacy
   * @param {callback} cb
   */
  getMapTypes: function getMapTypes(cb) {
    var url = this.getBaseUrl() + '?CMD=GETAVAILABLEMAPS&ACAO=TRUE';
    $.ajax({
      method: 'GET',
      url: url,
      success: function success(response) {
        try {
          return cb(null, response);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  }
};
function getCustomEventNodeByFilename(definitions, filename) {
  var result = [];
  definitions.each(function () {
    if ($(this).attr("filename") === filename) {
      result.push($(this));
    }
  });
  return result;
}
function getCustomEventNodeByFilenameAndCode(definitions, filename, code) {
  var definition = null;
  definitions.each(function () {
    if ($(this).attr("filename") === filename && parseInt($(this).attr("code")) === code) {
      definition = $(this);
      return false;
    }
  });
  return definition;
}

/**
 * @function checkTrackNameAvailability Returns true if list does'n consist track name or this track name for target filename
 * @param {Object[]} list
 * @param {string} trackInfo
 * @param {string} fileName
 * @returns {boolean} Is track name free
 */
function checkTrackNameAvailability(list, trackInfo, fileName) {
  var trackData;
  var folderNames = Object.keys(list);
  var trackNameIsAvailable = true;
  for (var i = 0; i < folderNames.length; i++) {
    trackData = list[folderNames[i]].find(function (track) {
      if (fileName && fileName === track.fileName && trackInfo.folderName === folderNames[i]) trackNameIsAvailable = false;
      return track.trackName === trackInfo.trackName;
    });
    if (trackData) break;
  }
  return !trackData || trackNameIsAvailable;
}
function getWeekDayLiteral(dayWeekNumber) {
  var weekday = {
    0: 'monday',
    1: 'tuesday',
    2: 'wednesday',
    3: 'thursday',
    4: 'friday',
    5: 'saturday',
    6: 'sunday'
  };
  return weekday[dayWeekNumber];
}
function weekDayToNumber(targetWeekday) {
  var weekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  return weekdays.findIndex(function (weekday) {
    return weekday === targetWeekday;
  });
}
function getFullRoute(fileName, folder) {
  var routeString = fileName;
  if (folder && folder !== 'default') routeString = folder + '/' + fileName;
  return routeString;
}
module.exports = followmeAPILegacy;

},{"./FollowMeMapUtils":2,"./track/EventCustomDefinition":9}],5:[function(require,module,exports){
'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var FollowMeMapUtils = require('./FollowMeMapUtils');
var EventCustomDefinition = require('./track/EventCustomDefinition');

/**
 * General object to provide followme API.
 * @namespace followmeAPIv2
 */
var followmeAPIv2 = {
  config: {
    dayEventsBaseUrl: window.CONSTANTS.DAY_EVENTS_BASE_URL,
    errorHandler: function ajaxErrorHandler(cb) {
      return function (jqXHR, textStatus, errorThrown) {
        return cb({
          message: errorThrown.message,
          textStatus: textStatus,
          origin: errorThrown
        });
      };
    },
    checkRequestStatus: function checkRequestStatus(response) {
      var status = response.find('STATUS');
      var error = response.find('ERROR');
      var e;
      if (error.length > 0) {
        console.error(error[0].outerHTML);
        throw new Error('Server error');
      }
      if (status.attr('value') !== 'OK') {
        e = new Error(status.attr('message'));
        e.errorcode = status.attr('errorcode');
        throw e;
      }
    },
    mapType: null
  },
  getBaseUrl: function getBaseUrl() {
    if (window.storage.getDebugUrl()) {
      return window.storage.getDebugUrl();
    }
    switch (window.storage.getAppMode()) {
      case CONSTANTS.APP_MODE_LEGACY:
        return window.CONSTANTS.BASE_URL_LEGACY;
      case CONSTANTS.APP_MODE_NORMAL:
      default:
        return window.CONSTANTS.BASE_URL;
    }
  },
  getManagementUrl: function getManagementUrl() {
    return window.CONSTANTS.BASE_URL_MANAGEMENT;
  },
  getStagingUrl: function getStagingUrl() {
    return window.CONSTANTS.BASE_URL_MANAGEMENT_STAGING;
  },
  setMapType: function setMapType(mapType) {
    this.config.mapType = mapType;
  },
  /**
   * Log a user against the Maptrip Manager
   * @async
   * @param {string} email
   * @param {string} password
   * @param {boolean} rememberMe
   * @param {loginCallback} cb
   * */
  login: function login(email, password, rememberMe, cb) {
    var url = this.getManagementUrl() + 'api/authenticate';
    $.ajax({
      type: 'POST',
      url: url,
      data: JSON.stringify({
        application: "followme",
        username: email,
        password: password,
        rememberMe: rememberMe
      }),
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      success: function success(result) {
        return cb(null, result.id_token);
      },
      error: function error(result) {
        var message = result.responseJSON.title;
        if (result.responseJSON.details) {
          message += ": " + result.responseJSON.details;
        }
        var translationKey = 'login-page.' + result.responseJSON.message;
        if (i18next.exists(translationKey)) {
          message = i18next.t(translationKey);
        }
        return cb(message, null);
      }
    });
  },
  userData: function userData(sessionid, cb) {
    var url = this.getManagementUrl() + 'api/user-data';
    var self = this;
    $.ajax({
      type: 'GET',
      url: url,
      headers: {
        'Authorization': 'Bearer ' + sessionid
      },
      success: function success(r) {
        var result;
        try {
          result = $(r);
          return cb(null, result[0]);
        } catch (e) {
          if (e.errorcode === '6') {
            return cb(null, false);
          }
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb),
      dataType: 'json'
    });
  },
  potInfo: function potInfo(sessionid, slug, cb) {
    var url = this.getManagementUrl() + 'pots/own/byapp/detailed/' + slug;
    var self = this;
    $.ajax({
      type: 'GET',
      url: url,
      headers: {
        'Authorization': 'Bearer ' + sessionid
      },
      success: function success(r) {
        var result;
        try {
          result = $(r);
          return cb(null, result[0]);
        } catch (e) {
          if (e.errorcode === '6') {
            return cb(null, false);
          }
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb),
      dataType: 'json'
    });
  },
  detourFilesLegacy: function detourFilesLegacy(sessionid, provider, cb) {
    var url = "https://detoureditor.maptrip.de/server/api/".concat(provider, "/?CMD=FILELIST&ACAO=true");
    var self = this;
    $.ajax({
      type: 'GET',
      url: url,
      headers: {
        'Authorization': 'Bearer ' + sessionid
      },
      success: function success(r) {
        var activeFile;
        try {
          $(r).find('file').each(function () {
            if ($(this).attr('active') === 'true') {
              activeFile = {
                id: $(this).attr('id'),
                name: $(this).attr('name'),
                potInfo: $(this).attr('user'),
                company: $(this).attr('company')
              };
            }
          });
          return cb(null, activeFile);
        } catch (e) {
          if (e.errorcode === '6') {
            return cb(null, false);
          }
          return cb(e);
        }
      },
      error: function error(err) {
        cb(err);
      },
      dataType: 'xml'
    });
  },
  detourActiveFile: function detourActiveFile(sessionid, provider, cb) {
    var url = "https://api.maptrip.de/v1/detour/maptrip/activefile?provider=".concat(provider, "&ACAO=true");
    var self = this;
    $.ajax({
      type: 'GET',
      url: url,
      headers: {
        'Authorization': 'Bearer ' + sessionid
      },
      success: function success(r) {
        var activeFile;
        if (r) {
          return cb(null, r.profile);
        } else {
          return cb(null, false);
        }
      },
      error: function error(err) {
        cb(err);
      },
      dataType: 'json'
    });
  },
  /**
   * Initiates the password reset process
   *
   * @async
   * @param {string} email
   * @param {string} callbackUrl - the url to be sent via e-mail to the user so they come here
   * @param {loginCallback} cb
   *
   */
  resetInit: function resetInit(email, callbackUrl, cb) {
    var url = this.getManagementUrl() + 'api/account/reset-password/init/fromapp';
    $.ajax({
      type: 'POST',
      url: url,
      data: {
        mail: email,
        callbackUrl: callbackUrl,
        desiredProduct: 'followme'
      },
      success: function success() {
        return cb(null);
      },
      error: function error(result) {
        var message = result.responseJSON.title;
        var translationKey = 'login-page.error.' + result.responseJSON.detail;
        if (i18next.exists(translationKey)) {
          message = i18next.t(translationKey);
        }
        return cb(message, null);
      }
    });
  },
  /**
   * Initiates the password reset process
   *
   * @async
   * @param passwordNew
   * @param key
   * @param {loginCallback} cb
   *
   */
  resetFinish: function resetFinish(passwordNew, key, cb) {
    var url = this.getManagementUrl() + 'api/account/reset-password/finish';
    $.ajax({
      type: 'POST',
      url: url,
      data: JSON.stringify({
        newPassword: passwordNew,
        key: key
      }),
      contentType: "application/json; charset=utf-8",
      success: function success() {
        return cb(null);
      },
      error: function error(result) {
        var message = result.responseJSON.title;
        var translationKey = 'reset-page.error.' + result.responseJSON.detail;
        var translationKey2 = 'reset-page.' + result.responseJSON.message;
        if (i18next.exists(translationKey)) {
          message = i18next.t(translationKey);
        } else if (i18next.exists(translationKey2)) {
          message = i18next.t(translationKey2);
        }
        return cb(message);
      }
    });
  },
  /**
   * Returns result of verification sessionid
   * @callback verifySessionIdCallback
   * @memberof followmeAPIv2
   * @param {object} error
   * @param {string} sessionid Should be used for access to another followme routes
   */
  /**
   * Verify sessionid token for user
   * @async
   * @param {string} sessionid
   * @param {verifySessionIdCallback} cb
   * */
  verifySessionId: function verifySessionId(sessionid, cb) {
    var url = this.getBaseUrl() + '?CMD=FILELIST&ACAO=TRUE';
    var self = this;
    $.ajax({
      type: 'GET',
      url: url,
      headers: {
        'Authorization': 'Bearer ' + sessionid
      },
      success: function success(r) {
        var result;
        try {
          result = $(r);
          self.config.checkRequestStatus(result);
          return cb(null, true);
        } catch (e) {
          if (e.errorcode === '6') {
            return cb(null, false);
          }
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb),
      dataType: 'xml'
    });
  },
  /**
   * Returns list of files for user
   * @callback fileListCallback
   * @memberof followmeAPIv2
   * @param {object} error
   * @param {Array} fileList
   */
  /**
   * Get user file list
   * @async
   * @param {string} sessionid Security token
   * @param {fileListCallback} cb
   * */
  fileList: function fileList(sessionid, cb) {
    var url = this.getBaseUrl() + '?CMD=FILELIST&ACAO=TRUE';
    var toIgnore = ['userSettings', 'dayevents'];
    var self = this;
    function parseRawFile(rawFile) {
      var j;
      var pv;
      var version;
      var date;
      var devices;
      var days;
      var d;
      var k;
      var versionStatusesAndRemarks = [];
      var versions = [];
      var fileStatusesAndRemarks = [];
      var associatedDevices = [];
      var jqFile = $(rawFile);
      var fileName = jqFile.attr('name');
      var jqAssociatedDevices = jqFile.find('DEVICE');
      var statusLastUpdate;
      var lastUsedDevice;
      jqAssociatedDevices.each(function (i, device) {
        associatedDevices.push($(device).attr('ID'));
      });
      window.storage.appendTrackDeviceIdAssociations({
        fileName: fileName,
        deviceIds: associatedDevices
      });
      pv = jqFile.find('version');
      for (j = 0; j < pv.length; j += 1) {
        version = {
          number: $(pv[j]).attr('value'),
          isTemporary: $(pv[j]).attr('temporaryVersionAvailable')
        };
        versionStatusesAndRemarks = [];
        versions.push(version);
        days = $(pv[j]).find('day');
        for (k = 0; k < days.length; k++) {
          var day = $(days[k]);
          date = day.attr('value');
          devices = day.find('device');
          for (d = 0; d < devices.length; d++) {
            var device = $(devices[d]);
            lastUsedDevice = devices[d].attributes.id.value;
            statusLastUpdate = device.attr('lastChangeStatusFile');
            versionStatusesAndRemarks.push({
              date: date,
              deviceId: devices[d].attributes.id.value,
              version: version,
              statusLastChangeDate: device.attr('lastChangeStatusFile'),
              remarksLastChangeDate: device.attr('lastChangeRemarksFile')
            });
          }
        }
        fileStatusesAndRemarks.push(versionStatusesAndRemarks);
      }
      return {
        fileName: fileName,
        trackName: fileName,
        creationDate: jqFile.attr('creationdate'),
        modificationDate: jqFile.attr('modificationdate'),
        description: jqFile.attr('description'),
        versions: versions,
        published: jqFile.attr('published'),
        statusLastUpdate: statusLastUpdate,
        lastUsedByDevice: lastUsedDevice,
        statusesAndRemarks: fileStatusesAndRemarks,
        associatedDevices: associatedDevices
      };
    }
    function parseFileForFolder(folderName, potId) {
      return function (files, rawFile) {
        if (toIgnore.indexOf(rawFile.attributes.name.value) !== -1) {
          return files;
        }
        var file = parseRawFile(rawFile);
        file.folderName = folderName;
        file.potId = potId;
        files.push(file);
        return files;
      };
    }
    $.ajax({
      type: 'GET',
      url: url,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", "Bearer " + sessionid);
      },
      error: this.config.errorHandler(cb),
      dataType: 'xml',
      success: function success(r) {
        var result;
        var folder;
        var rawFolders = {};
        var folders = {};
        var i;
        try {
          result = $(r);
          self.config.checkRequestStatus(result);
          rawFolders = result.find('folder');
          for (i = 0; i < rawFolders.length; i += 1) {
            folder = $(rawFolders[i]);
            var folderName = folder.attr('name');
            if (!folders[folderName]) {
              var potId = folder.attr('potId');
              folders[folderName] = folder.find('file').toArray().reduce(parseFileForFolder(folderName, potId), []);
            }
          }
          return cb(null, folders);
        } catch (e) {
          return cb(e);
        }
      }
    });
  },
  /**
   * Upload file to followme server
   * @async
   * @param {string} sessionid Security token
   * @param {string} data File data
   * @param {string} fileName File name
   * @param {object} trackInfo track information
   * @param {string|int} [trackInfo.version] Target file version
   * @param {string} [trackInfo.folderName] Route folder name
   * @param {defaultCallback} cb
   */
  uploadFile: function uploadFile(sessionid, data, fileName, trackInfo, cb) {
    var url = this.getBaseUrl() + '?CMD=SaveTemporaryPostedRoute&ACAO=TRUE' + '&type=route&route=' + encodeURI(getFullRoute(fileName, trackInfo.folderName));
    if (trackInfo.version) url += '&version=' + trackInfo.version;
    var self = this;
    $.ajax({
      method: 'POST',
      url: url,
      data: data,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", "Bearer " + sessionid);
      },
      success: function success(r) {
        var result;
        try {
          result = $(r);
          self.config.checkRequestStatus(result);
          return cb(null);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * Called with file data on success or with error on error
   * @callback getFileCallback
   * @memberof followmeAPIv2
   * @param {object} error
   * @param {string} fileData
   */
  /**
   * Get file from followme server
   * @async
   * @param {string} sessionid Security token
   * @param {string} fileName File name
   * @param {object} trackInfo file config
   * @param {number} trackInfo.version Target file version
   * @param {number} trackInfo.folderName file folder
   * @param {boolean} trackInfo.isTemporary is a temporary version
   * @param {getFileCallback} cb
   */
  getFile: function getFile(sessionid, fileName, trackInfo, cb) {
    var url = this.getBaseUrl() + '?CMD=GetFile&ACAO=TRUE' + '&type=route&version=' + trackInfo.version + '&route=' + getFullRoute(fileName, trackInfo.folderName);
    if (trackInfo.isTemporary) url += '&temporary=true';
    var self = this;
    $.ajax({
      method: 'GET',
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", "Bearer " + sessionid);
      },
      url: url,
      processData: false,
      success: function success(r) {
        var result;
        if (typeof r === 'string') return cb(null, r);
        try {
          result = $(r);
          self.config.checkRequestStatus(result);
          return cb(result);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * @function setRouteAttributes Set's file metadata
   * @async
   * @param sessionid Security token
   * @param {string} route File name
   * @param {object} attributes Key values map to set {key: 'value'}
   * @param {object} trackInfo route config
   * @param {object} trackInfo.folderName route config
   * @param {defaultCallback} cb
   */
  setRouteAttributes: function setRouteAttributes(sessionid, route, attributes, trackInfo, cb) {
    var url = this.getBaseUrl() + '?CMD=SetRouteAttributes&ACAO=TRUE&route=' + getFullRoute(route, trackInfo.folderName);
    url = Object.keys(attributes).reduce(function (urlString, attribute) {
      return urlString + '&' + encodeURI(attribute + '=' + attributes[attribute]);
    }, url);
    var self = this;
    $.ajax({
      method: 'POST',
      url: url,
      processData: false,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", "Bearer " + sessionid);
      },
      success: function success(r) {
        var result;
        try {
          result = $(r);
          self.config.checkRequestStatus(result);
          return cb(null);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * @function deleteFile Deletes file
   * @async
   * @param sessionid Security token
   * @param {string} fileName File name
   * @param {string} folder Folder name
   * @param {defaultCallback} cb
   */
  deleteFile: function deleteFile(sessionid, fileName, folder, cb) {
    var url = this.getBaseUrl() + '?CMD=DeleteFile&ACAO=TRUE&&route=' + getFullRoute(fileName, folder);
    var self = this;
    $.ajax({
      method: 'POST',
      url: url,
      processData: false,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", "Bearer " + sessionid);
      },
      success: function success(r) {
        var result;
        try {
          result = $(r);
          self.config.checkRequestStatus(result);
          return cb(null);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * Called with data or with error
   * @callback isTrackNameFreeCallback
   * @memberof followmeAPIv2
   * @param {object} error
   * @param {boolean} isTrackNameFree
   */
  /**
   * @function isTrackNameFree
   * @async
   * @param sessionid Security token
   * @param {string} trackInfo
   * @param {isTrackNameFreeCallback} cb
   * @param {string} fileName
   */
  isTrackNameFree: function isTrackNameFree(sessionid, trackInfo, fileName, cb) {
    var result;
    this.fileList(sessionid, function (e, list) {
      if (e) return cb(e);
      try {
        result = checkTrackNameAvailability(list, trackInfo, fileName);
        return cb(null, result);
      } catch (error) {
        return cb(error);
      }
    });
  },
  /**
   * @function uploadTrack Uploads track data and set's metadata
   * @memberof followmeAPIv2
   * @param {string} sessionid Security token
   * @param {string} route File name
   * @param {string} trackData
   * @param {object} trackInfo
   * @param {string} [trackInfo.trackName]
   * @param {string} [trackInfo.trackDescription]
   * @param {string} [trackInfo.creationDate]
   * @param {string} [trackInfo.version]
   * @param {string} [trackInfo.folderName]
   * @param {defaultCallback} cb
   */
  uploadTrack: function uploadTrack(sessionid, route, trackData, trackInfo, cb, overwriteFile) {
    var self = this;
    window.async.waterfall([function (callback) {
      if (!trackInfo.trackName) return callback(null, true);
      return self.isTrackNameFree(sessionid, trackInfo, route, callback);
    }, function (isNameFree, callback) {
      if (!isNameFree && !overwriteFile) return callback(new Error('Current track name is already in use'));
      return self.uploadFile(sessionid, trackData, route, {
        version: trackInfo.version,
        folderName: trackInfo.folderName
      }, callback);
    }, function (callback) {
      var mapType = window.storage.getSelectedMapType();
      var attributes = {
        modificationDate: new Date().toISOString(),
        mapName: mapType.name
      };
      if (trackInfo.trackName) attributes.trackName = trackInfo.trackName;
      if (trackInfo.creationDate) attributes.creationDate = trackInfo.creationDate;
      if (trackInfo.trackDescription) attributes.description = trackInfo.trackDescription;
      self.setRouteAttributes(sessionid, route, attributes, {
        folderName: trackInfo.folderName
      }, callback);
    }], function (e) {
      if (e) return cb(e);
      return cb(null);
    });
  },
  /**
   * @function updateTrackMetadata Used to change track name and description
   * @memberof followmeAPIv2
   * @async
   * @param {string} sessionId Security token
   * @param oldFileName
   * @param oldFolderName
   * @param newFileName
   * @param newFolderName
   * @param trackDescription
   * @param {defaultCallback} cb
   */
  updateTrackMetadata: function updateTrackMetadata(sessionId, oldFileName, oldFolderName, newFileName, newFolderName, trackDescription, cb) {
    var self = this;
    window.async.waterfall([function (callback) {
      self.isTrackNameFree(sessionId, newFileName, oldFileName, callback);
    }, function (isNameFree, callback) {
      if (!isNameFree) {
        return callback(new Error('Current track name is already in use'));
      }
      if (oldFolderName === newFolderName && oldFileName === newFileName) {
        return callback();
      }
      self.moveFile(sessionId, oldFolderName, newFolderName, oldFileName, newFileName, callback);
    }, function (callback) {
      var mapType = window.storage.getSelectedMapType();
      var attributes = {
        modificationDate: new Date().toISOString(),
        description: trackDescription,
        mapName: mapType.name
      };
      return self.setRouteAttributes(sessionId, newFileName, attributes, {
        folderName: newFolderName
      }, callback);
    }], function (e) {
      if (e) return cb(e);
      return cb(null);
    });
  },
  /**
   * @function dotsToTrackData Converts dots to track csv data
   * @memberof followmeAPIv2
   * @param {object[]} dotsArray Track dots
   * @param {string} dotsArray[].lat - Dot latitude.
   * @param {string} dotsArray[].lon - Dot longitude
   * @returns {string} Track csv data
   */
  dotsToTrackData: function dotsToTrackData(dotsArray) {
    var i;
    var data = 'lat;long;event.name;event.desc;event.color\n';
    var dots = dotsArray || [];
    var eventStr;
    for (i = 0; i < dots.length; i += 1) {
      if (_typeof(dots[i]) !== 'object' || dots[i].lon === undefined || dots[i].lat === undefined) continue;
      if (dots[i].event) {
        eventStr = ';' + dots[i].event.name + ';' + (dots[i].event.desc || dots[i].event.name) + ';' + (dots[i].event.color || '#ffffff');
      } else {
        eventStr = '';
      }
      data += dots[i].lat + ';' + dots[i].lon + eventStr + '\n';
    }
    return data;
  },
  /**
   * @function dotsToRouteData Converts dots to track csv data
   * @memberof followmeAPIv2
   * @param {Dots} dots Track dots
   * @param includeCustomEventDefinitions
   * @param {string} format
   * @param {boolean} keepExactContent
   * @returns {string} Track csv data
   */
  dotsToRouteData: function dotsToRouteData(dots, includeCustomEventDefinitions, format, keepExactContent) {
    if (!format) format = 'csv';
    return FollowMeMapUtils.prepareForExport(dots, includeCustomEventDefinitions, format, keepExactContent);
  },
  /**
   * @function getUserDevices: Returns current user devices in xml format
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {getUserDevicesCallback} cb
   */
  getUserDevices: function getUserDevices(sessionid, cb) {
    this.getUserPots(sessionid, function (result, error) {
      try {
        if (error) return cb(error);
        var devices = {};
        result.forEach(function (pot) {
          devices[pot.name] = [];
          pot.devices.forEach(function (device) {
            devices[pot.name].push({
              id: device.hwid,
              name: device.name
            });
          });
          if (pot.deviceGroups) {
            pot.deviceGroups.forEach(function (group) {
              group.devices.forEach(function (device) {
                if (!devices[pot.name].some(function (d) {
                  return d.id === device.hwid;
                })) {
                  devices[pot.name].push({
                    id: device.hwid,
                    name: device.name
                  });
                }
              });
            });
          }
        });
        cb(null, devices);
      } catch (error) {
        return cb(error);
      }
    });
  },
  getUserPots: function getUserPots(sessionid, cb) {
    var url = this.getManagementUrl() + 'api/pots/own/byapp/detailed/followme';
    $.ajax({
      method: 'GET',
      url: url,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", "Bearer " + sessionid);
      },
      success: function success(r) {
        try {
          return cb(r, null);
        } catch (e) {
          return cb(null, e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * Called with user settings on success or with error on error
   * @callback getUserSettingsCallback
   * @memberof followmeAPIv2
   * @param {Error} error
   * @param {xml} userSettings
   */
  /**
   * @function getUserSettings Returns current user settings in xml format
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {getUserSettingsCallback} cb
   */
  getUserSettings: function getUserSettings(sessionid, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=GetUserSettings&ACAO=TRUE';
    $.ajax({
      method: 'GET',
      url: url,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", "Bearer " + sessionid);
      },
      success: function success(r) {
        var status = $(r).find('STATUS');
        try {
          if (status.length > 0) {
            self.config.checkRequestStatus($(r));
          }
          return cb(null, r);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * Called with user settings on success or with error on error
   * @callback setUserSettingsCallback
   * @memberof followmeAPIv2
   * @param {Error} error
   * @param {xml} userSettings
   */
  /**
   * @function setUserSettings Sets current user settings
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {xml} settings User settings
   * @param {setUserSettingsCallback} cb
   */
  setUserSettings: function setUserSettings(sessionid, settings, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=SetUserSettings&ACAO=TRUE';
    $.ajax({
      method: 'POST',
      url: url,
      processData: false,
      data: settings,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", "Bearer " + sessionid);
      },
      success: function success(r) {
        var status = $(r).find('STATUS');
        try {
          if (status.length > 0) self.config.checkRequestStatus($(r));
          return cb(null, r);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * Called with array of custom user events on success or with error on error
   * @callback getUserEventsCallback
   * @memberof followmeAPIv2
   * @param {Error} error
   * @param {object[]} custom events
   */
  /**
   * @function getUserEvents Returns array of custom user events
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {getUserEventsCallback} cb
   */
  getUserEvents: function getUserEvents(sessionid, cb) {
    var url = this.getManagementUrl() + 'api/user-options/product/followme';
    $.ajax({
      type: 'GET',
      url: url,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", "Bearer " + sessionid);
      },
      contentType: "application/json",
      success: function success(result) {
        var events = {
          events: [],
          customEventDefinition: []
        };
        result.forEach(function (event) {
          if (event.type === "event") {
            try {
              var value = JSON.parse(event.value);
              events["events"].push({
                name: event["name"],
                id: event["id"],
                color: value["color"],
                desc: value["description"]
              });
            } catch (e) {
              console.error(e);
            }
          } else if (event.type === "customEventDefinition") {
            try {
              var _value = JSON.parse(event.value);
              _value._definition.code = event["id"];
              events["customEventDefinition"].push(new EventCustomDefinition(event["id"], _value["_color"], _value["_definition"], _value["_isDrawable"]));
            } catch (e) {
              console.error(e);
            }
          }
        });
        return cb(null, events);
      },
      error: function error(result) {
        var message = result.responseJSON.title;
        if (result.responseJSON.details) {
          message += ": " + result.responseJSON.details;
        }
        var translationKey = 'event.error.' + result.responseJSON.message;
        if (i18next.exists(translationKey)) {
          message = i18next.t(translationKey);
        }
        return cb(message, null);
      }
    });
  },
  /**
   * @function addUserEvent Adds new user created event
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {string} name Custom event name
   * @param {string} color Custom event color
   * @param {string} desc Event description
   * @param {defaultCallback} cb
   */
  addUserEvent: function addUserEvent(sessionid, name, color, desc, cb) {
    var url = this.getManagementUrl() + 'api/user-options/create';
    var event = {
      description: desc,
      color: color
    };
    $.ajax({
      type: 'POST',
      url: url,
      data: JSON.stringify({
        product: "followme",
        type: "event",
        name: name,
        visibility: "SHARED",
        value: JSON.stringify(event)
      }),
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", "Bearer " + sessionid);
      },
      contentType: "application/json",
      success: function success(result) {
        return cb(null);
      },
      error: function error(result) {
        var message = result.responseJSON.title;
        if (result.responseJSON.details) {
          message += ": " + result.responseJSON.details;
        }
        var translationKey = 'event.error.' + result.responseJSON.message;
        if (i18next.exists(translationKey)) {
          message = i18next.t(translationKey);
        }
        return cb(message);
      }
    });
  },
  addUserCustomEventDefinition: function addUserCustomEventDefinition(sessionid, name, definition, cb) {
    var url = this.getManagementUrl() + 'api/user-options/create';
    $.ajax({
      type: 'POST',
      url: url,
      data: JSON.stringify({
        product: "followme",
        type: "customEventDefinition",
        name: name,
        visibility: "SHARED",
        value: JSON.stringify(definition)
      }),
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", "Bearer " + sessionid);
      },
      contentType: "application/json",
      success: function success(result) {
        return cb(null, result);
      },
      error: function error(result) {
        var message = result.responseJSON.title;
        if (result.responseJSON.details) {
          message += ": " + result.responseJSON.details;
        }
        var translationKey = 'event.error.' + result.responseJSON.message;
        if (i18next.exists(translationKey)) {
          message = i18next.t(translationKey);
        }
        return cb(message);
      }
    });
  },
  /**
   * @function deleteUserEvent Deletes user event by id
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {string} id EventId
   * @param {defaultCallback} cb
   */
  deleteUserEvent: function addUserEvent(sessionid, id, cb) {
    var url = this.getManagementUrl() + 'api/user-options/' + id;
    $.ajax({
      type: 'DELETE',
      url: url,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", "Bearer " + sessionid);
      },
      contentType: "application/json",
      success: function success() {
        return cb(null);
      },
      error: function error(result) {
        var message = result.responseJSON.title;
        if (result.responseJSON.details) {
          message += ": " + result.responseJSON.details;
        }
        var translationKey = 'event.error.' + result.responseJSON.message;
        if (i18next.exists(translationKey)) {
          message = i18next.t(translationKey);
        }
        return cb(message);
      }
    });
  },
  getCustomEventDefinitions: function getCustomEventDefinitions(sessionid, trackname, callback) {
    this.getUserSettings(sessionid, function (e, data) {
      //TODO: Remove this hack after it applied
      var dataNeedsSaving = false;
      $(data).find('customeventdefinition').each(function () {
        var codeId = parseInt($(this).attr('code'));
        var contentId = parseInt(JSON.parse($(this).text())["code"]);
        if (codeId !== contentId) {
          dataNeedsSaving = true;
          $(this).attr("code", contentId);
        }
      });
      if (dataNeedsSaving) {
        try {
          this.setUserSettings(sessionid, data, function (a, b) {});
        } catch (e) {
          console.error(e);
        }
      }
      //TODO: Remove this hack after it applied

      this.saveCustomDefinitionEventsCache($(data));
      if (trackname === null) {
        return callback();
      }
      var i = 0;
      var events = [];
      var childNodes;

      // Edge support
      childNodes = getCustomEventNodeByFilename($(data).find('customeventdefinition'), trackname.replace(/ /g, '-'));
      for (i = 0; i < childNodes.length; i += 1) {
        try {
          var event = childNodes[i];
          events.push(new EventCustomDefinition(event.attr("code"), event.attr("color") ? event.attr("color") : "#5c9eed", JSON.parse(event.text()), true));
        } catch (e) {
          callback(e);
        }
      }
      callback(null, events);
    }.bind(this));
  },
  /**
   * Saves a new Custom Event Definition on the track
   *
   * @param code
   * @param {string} name
   * @param {string} color
   * @param {object} content
   */
  addNewEventCustomDefinition: function addNewEventCustomDefinition(code, name, color, content, cb) {
    var eventContent = {
      title: name,
      type: "object",
      code: code,
      properties: {},
      required: []
    };
    for (var property in content) {
      if (!content.hasOwnProperty(property)) continue;
      eventContent.properties[property] = {
        type: content[property].type
      };
      if (content[property].required) eventContent['required'].push(property);
    }
    var eventDefinition = new EventCustomDefinition(code, color, eventContent, true);
    var currentDefinitions = window.storage.getCustomEventDefinitions();
    if (!code) {
      this.addUserCustomEventDefinition(window.storage.getUserToken(), name, eventDefinition, function (err, res) {
        if (!err) {
          eventDefinition._id = res.id;
          eventDefinition.getDefinition().code = res.id;
          currentDefinitions.push(eventDefinition);
          window.storage.saveCustomEventDefinitions(currentDefinitions);
        }
        cb();
      });
    } else {
      this.modifyUserCustomEventDefinition(window.storage.getUserToken(), code, name, eventDefinition, function (err, res) {
        if (!err) {
          for (var i = 0; i < currentDefinitions.length; i++) {
            if (currentDefinitions[i]._definition.code === code) currentDefinitions[i] = eventDefinition;
          }
          window.storage.saveCustomEventDefinitions(currentDefinitions);
        }
        cb();
      });
    }
  },
  saveEventDefinitionsForTrack: function saveEventDefinitionsForTrack(sessionid, filename, definitions, parentCallback) {
    if (definitions.length === 0) return;
    var self = this;
    window.async.waterfall([function (callback) {
      self.getUserSettings(sessionid, callback);
    }, function (data, callback) {
      var customEventDefinitions;
      try {
        var settings = $(data).find('FollowMeServerUserSettings');
        customEventDefinitions = settings.find('customeventdefinitions');
        if (customEventDefinitions.length === 0) {
          customEventDefinitions = $("<customeventdefinitions>");
          settings.append(customEventDefinitions);
        }
        definitions.forEach(function (definition) {
          var customEventDefinition = getCustomEventNodeByFilenameAndCode(customEventDefinitions.find("customeventdefinition"), filename.replace(/ /g, '-'), definition.getId());
          if (customEventDefinition === null) {
            customEventDefinition = $("<customeventdefinition>");
            customEventDefinition.attr('filename', filename.replace(/ /g, '-'));
            customEventDefinition.attr('code', definition.getId());
            customEventDefinition.attr('timestamp', Date.now());
            customEventDefinitions.append(customEventDefinition);
          }
          customEventDefinition.attr('color', definition.getColor());
          customEventDefinition.text(JSON.stringify(definition.getDefinition()));
        });

        /*
        self.setUserSettings(sessionid, settings[0].outerHTML, callback);
        var newDefinitions = self.saveCustomDefinitionEventsCache(settings[0].outerHTML);
        window.updateCustomEventsDefinitions(null, newDefinitions);*/

        if (typeof parentCallback != 'undefined') {
          parentCallback();
        }
      } catch (e) {
        console.error("FollowmeApi.js:741", e);
        callback(e);
      }
    }]);
  },
  /**
   * Removes a custom event definition from the dots
   *
   * @param sessionid
   * @param filename
   * @param {int} code
   */
  removeEventCustomDefinition: function removeEventCustomDefinition(sessionid, code, cb) {
    this.deleteUserEvent(sessionid, code, function (err, res) {
      if (!err) {
        var currentDefinitions = window.storage.getCustomEventDefinitions();
        currentDefinitions = currentDefinitions.filter(function (definition) {
          return definition._id !== code;
        });
        window.storage.saveCustomEventDefinitions(currentDefinitions);
        cb();
      }
    });
  },
  saveCustomDefinitionEventsCache: function saveCustomDefinitionEventsCache(xml) {
    var definitions = {};
    $(xml).find('customeventdefinition').each(function () {
      var filename = $(this).attr("filename");
      if (!definitions.hasOwnProperty(filename)) {
        definitions[filename] = [];
      }
      definitions[filename].push(new EventCustomDefinition($(this).attr("code"), $(this).attr("color") ? $(this).attr("color") : "#5c9eed", JSON.parse($(this).text()), true));
    });
    window.storage.saveCustomEventDefinitions(definitions);
    return definitions;
  },
  /**
   * @function modifyUserEvent Deletes user event by id
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {string} id EventId
   * @param {string} name Event name
   * @param {string} color Event color
   * @param {string} desc Event description
   * @param {defaultCallback} cb
   */
  modifyUserEvent: function modifyUserEvent(sessionid, id, name, color, desc, cb) {
    var url = this.getManagementUrl() + 'api/user-options/update';
    var event = {
      description: desc,
      color: color
    };
    $.ajax({
      type: 'PUT',
      url: url,
      data: JSON.stringify({
        id: id,
        product: "followme",
        type: "event",
        name: name,
        visibility: "SHARED",
        value: JSON.stringify(event)
      }),
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", "Bearer " + sessionid);
      },
      contentType: "application/json",
      success: function success(result) {
        return cb(null);
      },
      error: function error(result) {
        var message = result.responseJSON.title;
        if (result.responseJSON.details) {
          message += ": " + result.responseJSON.details;
        }
        var translationKey = 'event.error.' + result.responseJSON.message;
        if (i18next.exists(translationKey)) {
          message = i18next.t(translationKey);
        }
        return cb(message);
      }
    });
  },
  modifyUserCustomEventDefinition: function modifyUserCustomEventDefinition(sessionid, id, name, definition, cb) {
    var url = this.getManagementUrl() + 'api/user-options/update';
    $.ajax({
      type: 'PUT',
      url: url,
      data: JSON.stringify({
        id: id,
        product: "followme",
        type: "customEventDefinition",
        name: name,
        visibility: "SHARED",
        value: JSON.stringify(definition)
      }),
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", "Bearer " + sessionid);
      },
      contentType: "application/json",
      success: function success(result) {
        return cb(null);
      },
      error: function error(result) {
        var message = result.responseJSON.title;
        if (result.responseJSON.details) {
          message += ": " + result.responseJSON.details;
        }
        var translationKey = 'event.error.' + result.responseJSON.message;
        if (i18next.exists(translationKey)) {
          message = i18next.t(translationKey);
        }
        return cb(message);
      }
    });
  },
  /**
   * @function createEventXmlRow Creates custom event in xml format
   * @memberOf followmeAPIv2
   * @param {string} id
   * @param {string} name
   * @param {string} color
   * @param {string} desc
   * @returns {HTMLElement}
   */
  createEventXmlRow: function createEventXmlRow(id, name, color, desc) {
    var doc = document.implementation.createDocument('', '', null);
    var event = doc.createElement('event');
    event.setAttribute('id', id);
    event.setAttribute('name', name);
    event.setAttribute('color', color);
    event.setAttribute('desc', desc);
    return event;
  },
  /**
   * Called with calculated route data on success or with error on error
   * @callback calculatePostedRouteCallback
   * @memberof followmeAPIv2
   * @param {Error} error
   * @param {data} Calculated route data
   */
  /**
   * @function calculatePostedRoute Created route for track
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {string} data Csv data with lat/long dots in mercator
   * @param {string} olrString
   * @param {calculatePostedRouteCallback} cb
   */
  calculatePostedRoute: function calculatePostedRoute(sessionid, data, olrString, cb) {
    var self = this;
    var encodedOlr = encodeURI(olrString);
    var url = this.getBaseUrl() + "?CMD=CalcPostedRoute&SP_USE=".concat(encodedOlr, "&ACAO=TRUE");
    if (this.config.mapType !== null) {
      if (this.config.mapType.hasOwnProperty('hasRouting') && this.config.mapType.hasRouting === false) {
        var userConfig = FollowMeMapUtils.getUserConfig();
        url += "&MAP=" + userConfig.defaultTo;
      } else {
        url += "&MAP=" + this.config.mapType.name;
      }
    }
    $.ajax({
      method: 'POST',
      url: url,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", "Bearer " + sessionid);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      },
      data: data,
      processData: false,
      success: function success(r) {
        var status = $(r).find('STATUS');
        try {
          if (status.length > 0) self.config.checkRequestStatus($(r));
          return cb(null, r);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * @function releasePostedRoute Publishes route for user access
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {string} data Csv data with lat/long dots
   * @param {string} route Route file name
   * @param {string} folderName Route folder name
   * @param {defaultCallback} cb
   */
  releasePostedRoute: function releasePostedRoute(sessionid, data, route, folderName, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=ReleasePostedRoute&ACAO=TRUE&route=' + getFullRoute(route, folderName);
    $.ajax({
      method: 'POST',
      url: url,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded',
        'Authorization': 'Bearer ' + sessionid
      },
      data: data,
      processData: false,
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * @function unReleaseRoute Unpublishes route for user access
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {string} route Route file name
   * @param {string} folderName file folder
   * @param {defaultCallback} cb
   */
  unReleaseRoute: function unReleaseRoute(sessionid, route, folderName, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=UnreleaseRoute&ACAO=TRUE&route=' + getFullRoute(route, folderName);
    $.ajax({
      method: 'POST',
      url: url,
      headers: {
        'Authorization': 'Bearer ' + sessionid
      },
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   *
   * @param sessionid
   * @param route
   * @param folder
   * @param deviceId
   * @param cb
   */
  addDeviceToTrack: function addDeviceToTrack(sessionid, route, folder, deviceId, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=AddDevice&ACAO=TRUE&device=' + deviceId + '&route=' + getFullRoute(route, folder);
    $.ajax({
      method: 'POST',
      url: url,
      headers: {
        'Authorization': 'Bearer ' + sessionid
      },
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   *
   * @param sessionid
   * @param route
   * @param folder
   * @param deviceId
   * @param cb
   */
  deleteDeviceFromTrack: function deleteDeviceFromTrack(sessionid, route, folder, deviceId, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=DeleteDevice&ACAO=TRUE&device=' + deviceId + '&route=' + getFullRoute(route, folder);
    $.ajax({
      method: 'POST',
      url: url,
      headers: {
        'Authorization': 'Bearer ' + sessionid
      },
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   *
   * @callback getRouteStatusesAndRemarksCallback
   * @memberof followmeAPIv2
   * @param {Error} error
   * @param {object} statusAndRemarks
   */
  /**
   * @function getRouteStatusesAndRemarks Returns route statuses and remarks
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {string} route File name
   * @param {string} folder Folder name
   * @param {getRouteStatusesAndRemarksCallback} cb
   */
  getRouteStatusesAndRemarks: function getRouteStatusesAndRemarks(sessionid, route, folder, cb) {
    folder = folder || 'default';
    var self = this;
    window.async.waterfall([function (cb) {
      self.fileList(sessionid, cb);
    }, function (fileList, cb) {
      var file = fileList[folder].find(function (file) {
        return file.fileName === route;
      });
      if (!file) return cb();
      cb(null, file.statusesAndRemarks);
    }], function (error, statusAndRemarks) {
      if (error) return cb(error);
      cb(null, statusAndRemarks);
    });
  },
  /**
   * @function getRouteRemark Returns target remarks
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {string} route File name
   * @param {string} date remarks date
   * @param {string} deviceId remarks deviceid
   * @param {number} version remarks version
   * @param {string} folderName route folder name
   * @param {defaultDataCallback} cb
   */
  getRouteRemark: function getRouteRemark(sessionid, route, date, deviceId, version, folderName, cb) {
    var url = this.getBaseUrl() + '?CMD=GetRemarks&ACAO=TRUE' + '&route=' + getFullRoute(route, folderName) + '&version=' + version + '&day=' + date + '&device=' + deviceId;
    $.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      headers: {
        'Authorization': 'Bearer ' + sessionid
      },
      error: this.config.errorHandler(cb),
      success: function success(r) {
        try {
          return cb(null, r);
        } catch (e) {
          return cb(e);
        }
      }
    });
  },
  /**
   * @function getRouteStatus Returns target status
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {string} route File name
   * @param {string} date remarks date
   * @param {string} deviceId remarks deviceid
   * @param {number} version remarks version
   * @param {string} folderName route folder name
   * @param olrstring
   * @param {defaultDataCallback} cb
   */
  getRouteStatus: function getRouteStatus(sessionid, route, date, deviceId, version, folderName, olrstring, cb) {
    var encodedOlr = encodeURI(olrstring);
    var url = this.getBaseUrl() + "?CMD=GetStatus&SP_USE=".concat(encodedOlr, "&ACAO=TRUE") + '&route=' + getFullRoute(route, folderName) + '&version=' + version + '&day=' + date + '&device=' + deviceId;
    if (this.config.mapType !== null) {
      url += "&MAP=" + this.config.mapType.name;
    }
    $.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      headers: {
        'Authorization': 'Bearer ' + sessionid
      },
      error: this.config.errorHandler(cb),
      success: function success(r) {
        try {
          return cb(null, r);
        } catch (e) {
          return cb(e);
        }
      }
    });
  },
  /**
   * @function uploadDayEvent Compresses and uploads day events data
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {string} data day events data
   * @param {defaultCallback} cb
   */
  uploadDayEvents: function uploadDayEvent(sessionid, data, cb) {
    var url = this.config.dayEventsBaseUrl + '?CMD=UploadFile&type=dayevents&ACAO=TRUE';
    $.ajax({
      method: 'POST',
      url: url,
      headers: {
        'Authorization': 'Bearer ' + sessionid,
        'Content-type': 'text/plain'
      },
      data: window.pako.deflate(data),
      processData: false,
      success: function success(r) {
        cb();
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * @function getDayEvents Returns parsed day events
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {defaultDataCallback} cb
   */
  getDayEvents: function getDayEvents(sessionid, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=GetDayEvents&ACAO=TRUE&version=0&route=dayevents';
    $.ajax({
      type: 'GET',
      url: url,
      headers: {
        'Authorization': 'Bearer ' + sessionid
      },
      error: this.config.errorHandler(cb),
      success: function success(r) {
        try {
          return cb(null, self.parseRawDayEvents(r));
        } catch (e) {
          return cb(e);
        }
      }
    });
  },
  /**
   * @function dayEventJsonToXml Converts day event object to xml row
   * @memberOf followmeAPIv2
   * @param {DayEvent} dayEvent
   */
  dayEventJsonToXml: function dayEventJsonToXml(dayEvent) {
    var wgs84cords = dayEvent.coordinates.toWGS84();
    return $("<DAYEVENT>", {
      description: dayEvent.name,
      coordx: wgs84cords._x,
      coordy: wgs84cords._y
    }).append($("<DATE>", {
      type: dayEvent.type,
      from: dayEvent.fromDate,
      to: dayEvent.toDate,
      weekday: weekDayToNumber(dayEvent.weekday)
    }))[0];
  },
  /**
   * @function dayEventsToXml Creates day events xml from DayEvent array
   * @memberOf followmeAPIv2
   * @param {DayEvent[]} dayEvents
   */
  dayEventsToXml: function dayEventsToXml(dayEvents) {
    var xmlVersion = '<?xml version="1.0"?>\n';
    var dayEventsRows = dayEvents.map(this.dayEventJsonToXml);
    var xml = $("<FOLLOWME>").append($('<DAYEVENTS>', {
      tour: ""
    }).append(dayEventsRows));
    return xmlVersion + xml[0].outerHTML;
  },
  /**
   *
   * @callback modifyDayEventsCallback
   * @memberof followmeAPIv2
   * @param {Error} error
   * @param {DayEvent[]} updatedDayEvents
   */
  /**
   * @function modifyDayEvents Loads day events passes to function and uploads to server
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {Function} fn function to modify day events array
   * @param {modifyDayEventsCallback} callback
   */
  modifyDayEvents: function addDayEvent(sessionid, fn, callback) {
    var self = this;
    var updatedDayEvents;
    window.async.waterfall([function (cb) {
      self.getDayEvents(sessionid, cb);
    }, function (dayEvents, cb) {
      try {
        dayEvents = fn(dayEvents);
        updatedDayEvents = dayEvents;
        self.uploadDayEvents(sessionid, self.dayEventsToXml(dayEvents), cb);
      } catch (e) {
        cb(e);
      }
    }], function (e) {
      callback(e, updatedDayEvents);
    });
  },
  /**
   * @function addDayEvent
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {DayEvent} dayEvent day event to add
   * @param {modifyDayEventsCallback} callback
   */
  addDayEvent: function addDayEvent(sessionid, dayEvent, callback) {
    function isEventNameUniq(dayEvents) {
      return !dayEvents.find(function (event) {
        return event.name === dayEvent.name;
      });
    }
    this.modifyDayEvents(sessionid, function (dayEvents) {
      if (!isEventNameUniq(dayEvents)) {
        throw new Error('Event name "' + dayEvent.name + '" already in use!');
      }
      dayEvents.push(dayEvent);
      return dayEvents;
    }, callback);
  },
  /**
   * @function parseRawDayEvents Convertes xml to DayEvent[]
   * @param {xml} rawDayEvents
   * @returns {DayEvent[]}
   */
  parseRawDayEvents: function parseRawDayEvents(rawDayEvents) {
    if (!rawDayEvents.features) {
      return [];
    }
    return rawDayEvents.features.map(function (feature) {
      return {
        name: feature.properties.TEXT,
        type: feature.properties.TYPE.toLowerCase(),
        weekday: getWeekDayLiteral(+feature.properties.WEEKDAY),
        fromDate: +feature.properties.UTC_FROM,
        toDate: +feature.properties.UTC_TO,
        coordinates: new IWCoordinate(feature.geometry.coordinates[0], feature.geometry.coordinates[1], IWCoordinate.MERCATOR)
      };
    });
  },
  /**
   * @function addDayEvent
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {string} originalName Original day event name
   * @param {DayEvent} dayEvent day event to update
   * @param {modifyDayEventsCallback} callback
   */
  updateDayEvent: function updateDayEvent(sessionid, originalName, dayEvent, callback) {
    this.modifyDayEvents(sessionid, function (dayEvents) {
      var targetEventIndex = dayEvents.findIndex(function (event) {
        return event.name === originalName;
      });
      if (targetEventIndex === -1) throw new Error('Event with name "' + originalName + '" do not exists!');
      dayEvents[targetEventIndex] = dayEvent;
      return dayEvents;
    }, callback);
  },
  /**
   * @function addDayEvent
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {DayEvent} dayEvent day event to delete
   * @param {modifyDayEventsCallback} callback
   */
  deleteDayEvent: function deleteDayEvent(sessionid, dayEvent, callback) {
    this.modifyDayEvents(sessionid, function (dayEvents) {
      dayEvents = dayEvents.filter(function (event) {
        return event.name !== dayEvent.name;
      });
      return dayEvents;
    }, callback);
  },
  /**
   * @function createFolder Creates folder for user
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {string} folderName
   * @param {defaultCallback} cb
   */
  createFolder: function createFolder(sessionid, folderName, cb) {
    var self = this;
    var url = this.config.dayEventsBaseUrl + '?CMD=CreateFolder&ACAO=TRUE&folder=/' + folderName;
    $.ajax({
      method: 'POST',
      url: url,
      processData: false,
      headers: {
        'Authorization': 'Bearer ' + sessionid
      },
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * @function renameFolder Renames folder of user
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {string} oldFolderName
   * @param {string} newFolderName
   * @param {defaultCallback} cb
   */
  renameFolder: function renameFolder(sessionid, oldFolderName, newFolderName, cb) {
    var self = this;
    var url = this.config.dayEventsBaseUrl + '?CMD=RenameFolder&ACAO=TRUE&' + 'folder=/' + oldFolderName + '&newFolder=/' + newFolderName;
    $.ajax({
      method: 'POST',
      url: url,
      processData: false,
      headers: {
        'Authorization': 'Bearer ' + sessionid
      },
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * @function deleteFolder Deletes user`s folder
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {string} folderName Folder to delete
   * @param {defaultCallback} cb
   */
  deleteFolder: function deleteFolder(sessionid, folderName, cb) {
    var self = this;
    var url = this.config.dayEventsBaseUrl + '?CMD=DeleteFolder&ACAO=TRUE&folder=/' + folderName;
    $.ajax({
      method: 'POST',
      url: url,
      processData: false,
      headers: {
        'Authorization': 'Bearer ' + sessionid
      },
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * @function moveFile moves file to new folder
   * @async
   * @memberOf followmeAPIv2
   * @param {string} sessionid Security token
   * @param {string} oldFolder Old folder name
   * @param {string} newFolder New folder name
   * @param {string} oldFileName
   * @param {string} newFileName
   * @param {defaultCallback} cb
   */
  moveFile: function moveFile(sessionid, oldFolder, newFolder, oldFileName, newFileName, cb) {
    var self = this;
    var url = this.getBaseUrl() + '?CMD=MoveFile&ACAO=TRUE' + '&folder=' + oldFolder + '&file=' + getFullRoute(oldFileName, oldFolder) + '&newPath=' + getFullRoute(newFileName, newFolder);
    $.ajax({
      method: 'POST',
      url: url,
      processData: false,
      headers: {
        'Authorization': 'Bearer ' + sessionid
      },
      success: function success(r) {
        try {
          self.config.checkRequestStatus($(r));
          return cb();
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  /**
   * @function getMapTypes Gets all the map types available on the NaviServer
   * @async
   * @memberOf followmeAPIv2
   * @param {callback} cb
   */
  getMapTypes: function getMapTypes(cb) {
    var url = this.getBaseUrl() + '?CMD=GETAVAILABLEMAPS&ACAO=TRUE';
    $.ajax({
      method: 'GET',
      url: url,
      success: function success(response) {
        try {
          return cb(null, response);
        } catch (e) {
          return cb(e);
        }
      },
      error: this.config.errorHandler(cb)
    });
  },
  isStaging: function isStaging() {
    return window.location.href.includes('localhost') || window.location.pathname.includes('staging');
  }
};
function getCustomEventNodeByFilename(definitions, filename) {
  var result = [];
  definitions.each(function () {
    if ($(this).attr("filename") === filename) {
      result.push($(this));
    }
  });
  return result;
}
function getCustomEventNodeByFilenameAndCode(definitions, filename, code) {
  var definition = null;
  definitions.each(function () {
    if ($(this).attr("filename") === filename && parseInt($(this).attr("code")) === code) {
      definition = $(this);
      return false;
    }
  });
  return definition;
}

/**
 * @function checkTrackNameAvailability Returns true if list does'n consist track name or this track name for target filename
 * @param {Object[]} list
 * @param {string} trackInfo
 * @param {string} fileName
 * @returns {boolean} Is track name free
 */
function checkTrackNameAvailability(list, trackInfo, fileName) {
  var trackData;
  var folderNames = Object.keys(list);
  var trackNameIsAvailable = true;
  for (var i = 0; i < folderNames.length; i++) {
    trackData = list[folderNames[i]].find(function (track) {
      if (fileName && fileName === track.fileName && trackInfo.folderName === folderNames[i]) trackNameIsAvailable = false;
      return track.trackName === trackInfo.trackName;
    });
    if (trackData) break;
  }
  return !trackData || trackNameIsAvailable;
}
function getWeekDayLiteral(dayWeekNumber) {
  var weekday = {
    0: 'monday',
    1: 'tuesday',
    2: 'wednesday',
    3: 'thursday',
    4: 'friday',
    5: 'saturday',
    6: 'sunday'
  };
  return weekday[dayWeekNumber];
}
function weekDayToNumber(targetWeekday) {
  var weekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  return weekdays.findIndex(function (weekday) {
    return weekday === targetWeekday;
  });
}
function getFullRoute(fileName, folder) {
  var routeString = fileName;
  if (folder && folder !== 'default') routeString = folder + '/' + fileName;
  return routeString;
}
module.exports = followmeAPIv2;

},{"./FollowMeMapUtils":2,"./track/EventCustomDefinition":9}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _FollowMeUtils = _interopRequireDefault(require("../FollowMeUtils"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Dot = exports["default"] = /*#__PURE__*/function () {
  function Dot(latitude, longitude, event) {
    _classCallCheck(this, Dot);
    this._latitude = latitude;
    this._longitude = longitude;
    this._event = event;
    this._marker = null;
    this._markerEvent = null;
  }
  return _createClass(Dot, [{
    key: "setLatitude",
    value: function setLatitude(latitude) {
      this._latitude = latitude;
      this._updateInheritedFields(this._event);
    }
  }, {
    key: "setLongitude",
    value: function setLongitude(longitude) {
      this._longitude = longitude;
      this._updateInheritedFields(this._event);
    }
  }, {
    key: "setEvent",
    value: function setEvent(event) {
      this._updateInheritedFields(event);
      this._event = event;
      window.followmeMap.buildDotTable();
    }
  }, {
    key: "setEventFromTable",
    value: function setEventFromTable(event) {
      this._updateInheritedFields(event);
      this._event = event;
    }
  }, {
    key: "setMarker",
    value: function setMarker(marker) {
      this._marker = marker;
    }
  }, {
    key: "setMarkerEvent",
    value: function setMarkerEvent(markerEvent) {
      this._markerEvent = markerEvent;
    }
  }, {
    key: "getLatitude",
    value: function getLatitude() {
      return this._latitude;
    }
  }, {
    key: "getLongitude",
    value: function getLongitude() {
      return this._longitude;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      // eslint-disable-next-line no-undef
      return new IWCoordinate(this._longitude, this._latitude, IWCoordinate.WGS84);
    }
  }, {
    key: "getEvent",
    value: function getEvent() {
      return this._event;
    }
  }, {
    key: "getMarker",
    value: function getMarker() {
      return this._marker;
    }
  }, {
    key: "getMarkerEvent",
    value: function getMarkerEvent() {
      return this._markerEvent;
    }
  }, {
    key: "getHash",
    value: function getHash() {
      return _FollowMeUtils["default"].hashString(this._latitude.toString() + this._longitude.toString() + JSON.stringify(this._event));
    }
  }, {
    key: "isDrawable",
    value: function isDrawable() {
      return typeof this._event === 'undefined' || this._event.constructor.name !== 'EventCustomDefinition';
    }
  }, {
    key: "hasEvent",
    value: function hasEvent() {
      return typeof this._event !== 'undefined';
    }
  }, {
    key: "hasMarkerEvent",
    value: function hasMarkerEvent() {
      return this._markerEvent !== null && typeof this._markerEvent !== 'undefined';
    }
  }, {
    key: "hasMarker",
    value: function hasMarker() {
      return this._marker !== null && typeof this._marker !== 'undefined';
    }
  }, {
    key: "clearEvent",
    value: function clearEvent() {
      this._event = undefined;
    }
  }, {
    key: "clearMarker",
    value: function clearMarker() {
      this._marker = null;
    }
  }, {
    key: "clearMarkerEvent",
    value: function clearMarkerEvent() {
      this._markerEvent = null;
    }
  }, {
    key: "_updateInheritedFields",
    value: function _updateInheritedFields(event) {
      if (!event || event.constructor.name !== 'EventCustom') return;
      var content = event.getContent();

      // eslint-disable-next-line no-restricted-syntax
      for (var item in content) {
        // eslint-disable-next-line no-continue
        if (!(item in content)) continue;
        if (['latitude', 'lat'].indexOf(item.toLowerCase()) !== -1) content[item] = this.getLatitude();
        if (['longitude', 'long', 'lng', 'lon'].indexOf(item.toLowerCase()) !== -1) content[item] = this.getLongitude();
      }
    }
  }]);
}();
module.exports = Dot;

},{"../FollowMeUtils":3}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Event = exports["default"] = /*#__PURE__*/function () {
  function Event(id, name, description, color, isDefault, isDrawable) {
    _classCallCheck(this, Event);
    this._id = id;
    this._name = name;
    this._description = description;
    this._color = color;
    this._isDefault = isDefault;
    this._isDrawable = isDrawable;
  }
  return _createClass(Event, [{
    key: "setIsDrawable",
    value: function setIsDrawable(isDrawable) {
      this._isDrawable = isDrawable;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this._id;
    }
  }, {
    key: "getName",
    value: function getName() {
      return this._name;
    }
  }, {
    key: "getDescription",
    value: function getDescription() {
      return this._description;
    }
  }, {
    key: "getColor",
    value: function getColor() {
      return this._color;
    }
  }, {
    key: "getIsDefault",
    value: function getIsDefault() {
      return this._isDefault;
    }
  }, {
    key: "getIsEditable",
    value: function getIsEditable() {
      return !this._isDefault || this._id >= 45000 && this._id < 46000;
    }
  }, {
    key: "getIsDrawable",
    value: function getIsDrawable() {
      return this._isDrawable;
    }
  }]);
}();
module.exports = Event;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EventCustom = exports["default"] = /*#__PURE__*/function () {
  function EventCustom(id, name, content, color, isDrawable) {
    _classCallCheck(this, EventCustom);
    this._id = id;
    this._name = name;
    this._content = content;
    this._color = color;
    this._isDrawable = isDrawable;
  }
  return _createClass(EventCustom, [{
    key: "setIsDrawable",
    value: function setIsDrawable(isDrawable) {
      this._isDrawable = isDrawable;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this._id;
    }
  }, {
    key: "getName",
    value: function getName() {
      return this._name;
    }
  }, {
    key: "getContent",
    value: function getContent() {
      return this._content;
    }
  }, {
    key: "getColor",
    value: function getColor() {
      return this._color;
    }
  }, {
    key: "getIsDrawable",
    value: function getIsDrawable() {
      return this._isDrawable;
    }
  }], [{
    key: "getIsEditable",
    value: function getIsEditable() {
      return true;
    }
  }]);
}();
module.exports = EventCustom;

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EventCustomDefinition = exports["default"] = /*#__PURE__*/function () {
  function EventCustomDefinition(id, color, definition, isDrawable) {
    _classCallCheck(this, EventCustomDefinition);
    this._id = id;
    this._color = color;
    this._definition = definition;
    this._isDrawable = isDrawable;
  }
  return _createClass(EventCustomDefinition, [{
    key: "setIsDrawable",
    value: function setIsDrawable(isDrawable) {
      this._isDrawable = isDrawable;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this._id;
    }
  }, {
    key: "getColor",
    value: function getColor() {
      return this._color;
    }
  }, {
    key: "getDefinition",
    value: function getDefinition() {
      return this._definition;
    }
  }, {
    key: "getIsDrawable",
    value: function getIsDrawable() {
      return this._isDrawable;
    }
  }], [{
    key: "getIsEditable",
    value: function getIsEditable() {
      return false;
    }
  }]);
}();
if (typeof window !== 'undefined') window.EventCustomDefinition = EventCustomDefinition;
module.exports = EventCustomDefinition;

},{}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var NMEAFormatter = exports["default"] = /*#__PURE__*/function () {
  function NMEAFormatter() {
    _classCallCheck(this, NMEAFormatter);
  }
  return _createClass(NMEAFormatter, [{
    key: "getTime",
    value:
    /**
     * @private
     */
    function getTime(date) {
      var hours = date.getUTCHours();
      var minutes = date.getUTCMinutes();
      var seconds = date.getUTCSeconds();
      return '' + (hours < 10 ? '0' + hours : hours) + (minutes < 10 ? '0' + minutes : minutes) + (seconds < 10 ? '0' + seconds : seconds);
    }
  }, {
    key: "format",
    value: function format(coordinate) {
      var wgs84 = coordinate.toWGS84();
      var timestamp = new Date();
      var time = this.getTime(timestamp);
      var date = this.getDateDayFirst(timestamp);
      var lat = this.getDegreeMinutesSeconds(wgs84.getY(), 'latitude');
      var lon = this.getDegreeMinutesSeconds(wgs84.getX(), 'longitude');
      var rmc = 'GPRMC,' + time + ',A,' + lat + ',' + lon + ',,,' + date + ',,,A';
      return '$' + rmc + '*' + this.getChecksum(rmc);
    }

    /**
     * @private
     */
  }, {
    key: "getDateDayFirst",
    value: function getDateDayFirst(date) {
      var year = date.getUTCFullYear();
      var month = date.getUTCMonth() + 1;
      var day = date.getUTCDate();
      return '' + (day < 10 ? '0' + day : day) + (month < 10 ? '0' + month : month) + year % 100;
    }

    /**
     * @private
     */
  }, {
    key: "getDegreeMinutesSeconds",
    value: function getDegreeMinutesSeconds(degreesDecimal, mode) {
      var negative = degreesDecimal < 0;
      degreesDecimal = Math.abs(degreesDecimal);
      var degrees = Math.floor(degreesDecimal);
      var remainder = degreesDecimal - degrees;
      var minutes = Math.floor(60 * remainder);
      remainder = 60 * remainder - minutes; // 60 * remainder is the decimal value for minutes and seconds

      var s = Math.floor(remainder * 10000);
      var minuteFraction = s < 10 ? '000' + s : s < 100 ? '00' + s : s < 1000 ? '0' + s : '' + s;
      var hemisphere;
      if (mode === 'latitude') {
        // return XXYY.ZZZZ,b which is XXºYY'ZZZZ'' with being N or S
        hemisphere = negative ? 'S' : 'N';
        return this.toTwoPlaces(degrees) + this.toTwoPlaces(minutes) + '.' + minuteFraction + ',' + hemisphere;
      }

      // return XXXYY.ZZZZ,l which is XXºYY'ZZZZ'' with l being W or E
      hemisphere = negative ? 'W' : 'E';
      return this.toThreePlaces(degrees) + this.toTwoPlaces(minutes) + '.' + minuteFraction + ',' + hemisphere;
    }

    /**
     * @private
     */
  }, {
    key: "toTwoPlaces",
    value: function toTwoPlaces(n) {
      if (n < 10) return '0' + n;
      return n.toString();
    }

    /**
     * @private
     */
  }, {
    key: "toThreePlaces",
    value: function toThreePlaces(n) {
      if (n < 10) return '00' + n;
      if (n < 100) return '0' + n;
      return n.toString();
    }

    /**
     * Returns the bitwise XOR of the ASCII codes in the specified string (as a hexadecimal number).
     * @private
     */
  }, {
    key: "getChecksum",
    value: function getChecksum(s) {
      var checksum = 0;
      for (var i = 0; i < s.length; i++) {
        checksum ^= s.charCodeAt(i);
      }
      return checksum.toString(16).toUpperCase();
    }
  }]);
}();
module.exports = NMEAFormatter;

},{}]},{},[5,4,1])

